/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AIAssistantUnlockResponse } from '../models';
// @ts-ignore
import type { AddCourseImageQuestionsBody } from '../models';
// @ts-ignore
import type { AddCourseImageQuestionsResponse } from '../models';
// @ts-ignore
import type { AddSeriesCourseBody } from '../models';
// @ts-ignore
import type { AdminCourseFeedbackResponse } from '../models';
// @ts-ignore
import type { AdminCoursesListResponse } from '../models';
// @ts-ignore
import type { AdminGenerateIntrosBody } from '../models';
// @ts-ignore
import type { AdminGenerateIntrosResponse } from '../models';
// @ts-ignore
import type { AdminGenerateReadingMaterialBody } from '../models';
// @ts-ignore
import type { AdminGenerateReadingMaterialResponse } from '../models';
// @ts-ignore
import type { AdminIntroStatusResponse } from '../models';
// @ts-ignore
import type { AdminNarrateBody } from '../models';
// @ts-ignore
import type { AdminNarrateResponse } from '../models';
// @ts-ignore
import type { AdminReadingMaterialCostEstimateResponse } from '../models';
// @ts-ignore
import type { AdminReadingMaterialStatusResponse } from '../models';
// @ts-ignore
import type { AdminRegenerateReadingMaterialBody } from '../models';
// @ts-ignore
import type { AttemptQuestionBody } from '../models';
// @ts-ignore
import type { CloseTopicJumpResponse } from '../models';
// @ts-ignore
import type { CloseTopicTestResponse } from '../models';
// @ts-ignore
import type { CompleteIntroResponse } from '../models';
// @ts-ignore
import type { CompleteLabelResponse } from '../models';
// @ts-ignore
import type { ContinueCourseBuildResponse } from '../models';
// @ts-ignore
import type { CoreSkillDetailResponse } from '../models';
// @ts-ignore
import type { CoreSkillDuplicatesResponse } from '../models';
// @ts-ignore
import type { CoreSkillGapsResponse } from '../models';
// @ts-ignore
import type { CourseBuildEstimate } from '../models';
// @ts-ignore
import type { CourseBuildHierarchyResponse } from '../models';
// @ts-ignore
import type { CourseBuildJobDetail } from '../models';
// @ts-ignore
import type { CourseBuildJobListResponse } from '../models';
// @ts-ignore
import type { CourseBuildJobStarted } from '../models';
// @ts-ignore
import type { CourseBuildReadiness } from '../models';
// @ts-ignore
import type { CourseImageQuestionsResponse } from '../models';
// @ts-ignore
import type { CourseNarrationCoverageResponse } from '../models';
// @ts-ignore
import type { CoursePromotionResponse } from '../models';
// @ts-ignore
import type { CoursePromotionTestEmailBody } from '../models';
// @ts-ignore
import type { CoursePromotionTestEmailResponse } from '../models';
// @ts-ignore
import type { CreateCoursePromotionBody } from '../models';
// @ts-ignore
import type { CreateSkillReviewBody } from '../models';
// @ts-ignore
import type { CreateTopicsSubtopicsBody } from '../models';
// @ts-ignore
import type { DeleteCourseResponse } from '../models';
// @ts-ignore
import type { DismissCourseReviewBody } from '../models';
// @ts-ignore
import type { DismissCourseReviewResponse } from '../models';
// @ts-ignore
import type { DismissProgressResetNoticeResponse } from '../models';
// @ts-ignore
import type { EnsureLabelBuiltResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GenerateCodingQuestionsBody } from '../models';
// @ts-ignore
import type { GenerateCodingQuestionsResponse } from '../models';
// @ts-ignore
import type { GenerateGuidedCourseCertificateResponse } from '../models';
// @ts-ignore
import type { GenerateImageDensitySampleResponse } from '../models';
// @ts-ignore
import type { GenerateImageOnlyQuestionsBody } from '../models';
// @ts-ignore
import type { GenerateImageOnlyQuestionsResponse } from '../models';
// @ts-ignore
import type { GetCoursePromotionListResponse } from '../models';
// @ts-ignore
import type { GetCoursePromotionResponse } from '../models';
// @ts-ignore
import type { GetCreatorSkillsResponse } from '../models';
// @ts-ignore
import type { GetGuidedCourseRelevanceResponse } from '../models';
// @ts-ignore
import type { GetGuidedCoursesResponse } from '../models';
// @ts-ignore
import type { GetIntroContentResponse } from '../models';
// @ts-ignore
import type { GetLabelContentResponse } from '../models';
// @ts-ignore
import type { GetPublicSeriesListResponse } from '../models';
// @ts-ignore
import type { GetPublicSkillDetailResponse } from '../models';
// @ts-ignore
import type { GetPublicSkillsHubResponse } from '../models';
// @ts-ignore
import type { GetPublicSkillsListResponse } from '../models';
// @ts-ignore
import type { GetSkillBrowseResponse } from '../models';
// @ts-ignore
import type { GetSkillCategoriesResponse } from '../models';
// @ts-ignore
import type { GetSkillFAQListResponse } from '../models';
// @ts-ignore
import type { GetSkillModuleTodosResponse } from '../models';
// @ts-ignore
import type { GetSkillNameHierarchyResponse } from '../models';
// @ts-ignore
import type { GetSkillPreferencesResponse } from '../models';
// @ts-ignore
import type { GetSkillRelatedCoursesResponse } from '../models';
// @ts-ignore
import type { GetSkillReviewListResponse } from '../models';
// @ts-ignore
import type { GetSkillSeriesListResponse } from '../models';
// @ts-ignore
import type { GetSkillStatsResponse } from '../models';
// @ts-ignore
import type { GetSkillsListBySkillTypeResponse } from '../models';
// @ts-ignore
import type { GetSkillsResponse } from '../models';
// @ts-ignore
import type { GetSkillsResponseMain } from '../models';
// @ts-ignore
import type { GetSkillsStartStatisticsResponse } from '../models';
// @ts-ignore
import type { GetSkillsV2ResponseMain } from '../models';
// @ts-ignore
import type { GetTheoryAIChatsResponse } from '../models';
// @ts-ignore
import type { GuidedAttemptResponse } from '../models';
// @ts-ignore
import type { GuidedCourseCertificateResponse } from '../models';
// @ts-ignore
import type { GuidedCourseEnrollResponse } from '../models';
// @ts-ignore
import type { GuidedCourseInfoResponse } from '../models';
// @ts-ignore
import type { GuidedCourseMapResponse } from '../models';
// @ts-ignore
import type { GuidedCourseProgressResponse } from '../models';
// @ts-ignore
import type { GuidedCoursesProgressResponse } from '../models';
// @ts-ignore
import type { GuidedSessionProgressResponse } from '../models';
// @ts-ignore
import type { IDList } from '../models';
// @ts-ignore
import type { IDNames } from '../models';
// @ts-ignore
import type { LessonBuildStatusResponse } from '../models';
// @ts-ignore
import type { ListSeriesCoursesResponse } from '../models';
// @ts-ignore
import type { NameList } from '../models';
// @ts-ignore
import type { OpeningBackfillBody } from '../models';
// @ts-ignore
import type { OpeningBackfillResponse } from '../models';
// @ts-ignore
import type { PreviewCoursePromotionBody } from '../models';
// @ts-ignore
import type { PreviewCoursePromotionResponse } from '../models';
// @ts-ignore
import type { PruneOrphanSkillsBody } from '../models';
// @ts-ignore
import type { PruneOrphanSkillsResponse } from '../models';
// @ts-ignore
import type { PublicListingBody } from '../models';
// @ts-ignore
import type { PublishModuleBody } from '../models';
// @ts-ignore
import type { PublishModuleResponse } from '../models';
// @ts-ignore
import type { PublishReadinessResponse } from '../models';
// @ts-ignore
import type { PublishStatusResponse } from '../models';
// @ts-ignore
import type { PurchaseCourseResponse } from '../models';
// @ts-ignore
import type { ReadingMaterialResponse } from '../models';
// @ts-ignore
import type { RebuildLabelBody } from '../models';
// @ts-ignore
import type { RebuildLabelResponse } from '../models';
// @ts-ignore
import type { RecomputeSkillImageDensityResponse } from '../models';
// @ts-ignore
import type { RecomputeSkillQualityResponse } from '../models';
// @ts-ignore
import type { ReorderSeriesBody } from '../models';
// @ts-ignore
import type { ResolveCoreSkillReviewBody } from '../models';
// @ts-ignore
import type { ResponseResult } from '../models';
// @ts-ignore
import type { ReviewCoreSkillsBody } from '../models';
// @ts-ignore
import type { ReviewCoreSkillsResponse } from '../models';
// @ts-ignore
import type { ReviewHierarchyOrderBody } from '../models';
// @ts-ignore
import type { SetCoreSkillExclusionBody } from '../models';
// @ts-ignore
import type { SetCoreSkillExclusionResponse } from '../models';
// @ts-ignore
import type { SetCourseIntroVisibilityBody } from '../models';
// @ts-ignore
import type { SetCourseIntroVisibilityResponse } from '../models';
// @ts-ignore
import type { SetCoursePricingBody } from '../models';
// @ts-ignore
import type { SetCoursePricingResponse } from '../models';
// @ts-ignore
import type { SetSkillGenerationPromptBody } from '../models';
// @ts-ignore
import type { SkillAliasAvailabilityResponse } from '../models';
// @ts-ignore
import type { SkillBadgesResponse } from '../models';
// @ts-ignore
import type { SkillBuilderCertificateProgressResponse } from '../models';
// @ts-ignore
import type { SkillBuilderCertificateResponse } from '../models';
// @ts-ignore
import type { SkillContentResponse } from '../models';
// @ts-ignore
import type { SkillCostEstimateResponse } from '../models';
// @ts-ignore
import type { SkillDashboardSummaryResponse } from '../models';
// @ts-ignore
import type { SkillFAQItem } from '../models';
// @ts-ignore
import type { SkillGenerationPromptResponse } from '../models';
// @ts-ignore
import type { SkillImageUploadResponse } from '../models';
// @ts-ignore
import type { SkillPercentileResponse } from '../models';
// @ts-ignore
import type { SkillReportResponse } from '../models';
// @ts-ignore
import type { SkillReviewItem } from '../models';
// @ts-ignore
import type { SkillSeriesItem } from '../models';
// @ts-ignore
import type { StartCourseBuildBody } from '../models';
// @ts-ignore
import type { StartGuidedLabelSessionBody } from '../models';
// @ts-ignore
import type { StartGuidedLabelSessionResponse } from '../models';
// @ts-ignore
import type { StartGuidedTopicSessionResponse } from '../models';
// @ts-ignore
import type { StreakResponse } from '../models';
// @ts-ignore
import type { SubmitCourseFeedbackBody } from '../models';
// @ts-ignore
import type { SubmitCourseFeedbackResponse } from '../models';
// @ts-ignore
import type { SubmitCourseReviewBody } from '../models';
// @ts-ignore
import type { SubmitCourseReviewResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { TheoryAIChatBody } from '../models';
// @ts-ignore
import type { TheoryAIChatResponse } from '../models';
// @ts-ignore
import type { ToggleGuidedCourseBody } from '../models';
// @ts-ignore
import type { ToggleGuidedCourseResponse } from '../models';
// @ts-ignore
import type { TopicJumpResult } from '../models';
// @ts-ignore
import type { TopicTestAttemptResponse } from '../models';
// @ts-ignore
import type { TopicTestProgressResponse } from '../models';
// @ts-ignore
import type { TopicTestResult } from '../models';
// @ts-ignore
import type { UnansweredQuestionResponseSchemaSkillDict } from '../models';
// @ts-ignore
import type { UpdateAllowImagesBody } from '../models';
// @ts-ignore
import type { UpdateAllowImagesResponse } from '../models';
// @ts-ignore
import type { UpdateSkillCategoriesBody } from '../models';
// @ts-ignore
import type { UpdateSkillHiddenBody } from '../models';
// @ts-ignore
import type { UpdateSkillHiddenResponse } from '../models';
// @ts-ignore
import type { UpdateSkillReviewBody } from '../models';
// @ts-ignore
import type { UpsertSkillContentBody } from '../models';
// @ts-ignore
import type { UpsertSkillFAQBody } from '../models';
// @ts-ignore
import type { UpsertSkillSeriesBody } from '../models';
// @ts-ignore
import type { UserRatingParams } from '../models';
// @ts-ignore
import type { UserSkillBuilderMetadata } from '../models';
/**
 * SkillApiApi - axios parameter creator
 */
export const SkillApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * checked against its figure before it goes live; re-running tops up the gap.
         * @summary Add figure questions to a course\'s built lessons. Each is judged, drawn and
         * @param {string} moduleId 
         * @param {AddCourseImageQuestionsBody} addCourseImageQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAddCourseImageQuestions: async (moduleId: string, addCourseImageQuestionsBody: AddCourseImageQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('skillApiAddCourseImageQuestions', 'moduleId', moduleId)
            // verify required parameter 'addCourseImageQuestionsBody' is not null or undefined
            assertParamExists('skillApiAddCourseImageQuestions', 'addCourseImageQuestionsBody', addCourseImageQuestionsBody)
            const localVarPath = `/admin/skill/{module_id}/image-questions`
                .replace('{module_id}', encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCourseImageQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesId 
         * @param {AddSeriesCourseBody} addSeriesCourseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAddSeriesCourse: async (seriesId: string, addSeriesCourseBody: AddSeriesCourseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesId' is not null or undefined
            assertParamExists('skillApiAddSeriesCourse', 'seriesId', seriesId)
            // verify required parameter 'addSeriesCourseBody' is not null or undefined
            assertParamExists('skillApiAddSeriesCourse', 'addSeriesCourseBody', addSeriesCourseBody)
            const localVarPath = `/admin/skill-series/{series_id}/courses`
                .replace('{series_id}', encodeURIComponent(String(seriesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSeriesCourseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} rating 
         * @param {string} skillId 
         * @param {UserRatingParams} userRatingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAddSkillRating: async (rating: string, skillId: string, userRatingParams: UserRatingParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rating' is not null or undefined
            assertParamExists('skillApiAddSkillRating', 'rating', rating)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiAddSkillRating', 'skillId', skillId)
            // verify required parameter 'userRatingParams' is not null or undefined
            assertParamExists('skillApiAddSkillRating', 'userRatingParams', userRatingParams)
            const localVarPath = `/skill/{skill_id}/user-rating/{rating}`
                .replace('{rating}', encodeURIComponent(String(rating)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRatingParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {AdminGenerateIntrosBody} adminGenerateIntrosBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminGenerateCourseIntros: async (moduleId: string, adminGenerateIntrosBody: AdminGenerateIntrosBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('skillApiAdminGenerateCourseIntros', 'moduleId', moduleId)
            // verify required parameter 'adminGenerateIntrosBody' is not null or undefined
            assertParamExists('skillApiAdminGenerateCourseIntros', 'adminGenerateIntrosBody', adminGenerateIntrosBody)
            const localVarPath = `/admin/skill/{module_id}/intros/generate`
                .replace('{module_id}', encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminGenerateIntrosBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {AdminGenerateReadingMaterialBody} adminGenerateReadingMaterialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminGenerateMissingReadingMaterial: async (skillId: string, adminGenerateReadingMaterialBody: AdminGenerateReadingMaterialBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiAdminGenerateMissingReadingMaterial', 'skillId', skillId)
            // verify required parameter 'adminGenerateReadingMaterialBody' is not null or undefined
            assertParamExists('skillApiAdminGenerateMissingReadingMaterial', 'adminGenerateReadingMaterialBody', adminGenerateReadingMaterialBody)
            const localVarPath = `/admin/skill/{skill_id}/reading-material/generate-missing`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminGenerateReadingMaterialBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {AdminGenerateReadingMaterialBody} adminGenerateReadingMaterialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminGenerateReadingMaterial: async (skillId: string, adminGenerateReadingMaterialBody: AdminGenerateReadingMaterialBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiAdminGenerateReadingMaterial', 'skillId', skillId)
            // verify required parameter 'adminGenerateReadingMaterialBody' is not null or undefined
            assertParamExists('skillApiAdminGenerateReadingMaterial', 'adminGenerateReadingMaterialBody', adminGenerateReadingMaterialBody)
            const localVarPath = `/admin/skill/{skill_id}/reading-material/generate`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminGenerateReadingMaterialBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminGetCourseIntros: async (moduleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('skillApiAdminGetCourseIntros', 'moduleId', moduleId)
            const localVarPath = `/admin/skill/{module_id}/intros`
                .replace('{module_id}', encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminGetReadingMaterialCostEstimate: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiAdminGetReadingMaterialCostEstimate', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/reading-material/cost-estimate`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminGetReadingMaterialStatus: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiAdminGetReadingMaterialStatus', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/reading-material/status`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {AdminNarrateBody} adminNarrateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminNarrateCourse: async (skillId: string, adminNarrateBody: AdminNarrateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiAdminNarrateCourse', 'skillId', skillId)
            // verify required parameter 'adminNarrateBody' is not null or undefined
            assertParamExists('skillApiAdminNarrateCourse', 'adminNarrateBody', adminNarrateBody)
            const localVarPath = `/admin/skill/{skill_id}/reading-material/narrate-course`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminNarrateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {AdminNarrateBody} adminNarrateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminNarrateLabel: async (skillId: string, adminNarrateBody: AdminNarrateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiAdminNarrateLabel', 'skillId', skillId)
            // verify required parameter 'adminNarrateBody' is not null or undefined
            assertParamExists('skillApiAdminNarrateLabel', 'adminNarrateBody', adminNarrateBody)
            const localVarPath = `/admin/skill/{skill_id}/reading-material/narrate-label`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminNarrateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminNarrationCoverage: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiAdminNarrationCoverage', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/reading-material/narration-coverage`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {AdminGenerateReadingMaterialBody} adminGenerateReadingMaterialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminRegeneratePoorReadingMaterial: async (skillId: string, adminGenerateReadingMaterialBody: AdminGenerateReadingMaterialBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiAdminRegeneratePoorReadingMaterial', 'skillId', skillId)
            // verify required parameter 'adminGenerateReadingMaterialBody' is not null or undefined
            assertParamExists('skillApiAdminRegeneratePoorReadingMaterial', 'adminGenerateReadingMaterialBody', adminGenerateReadingMaterialBody)
            const localVarPath = `/admin/skill/{skill_id}/reading-material/regenerate-poor`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminGenerateReadingMaterialBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {AdminRegenerateReadingMaterialBody} adminRegenerateReadingMaterialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminRegenerateReadingMaterial: async (skillId: string, adminRegenerateReadingMaterialBody: AdminRegenerateReadingMaterialBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiAdminRegenerateReadingMaterial', 'skillId', skillId)
            // verify required parameter 'adminRegenerateReadingMaterialBody' is not null or undefined
            assertParamExists('skillApiAdminRegenerateReadingMaterial', 'adminRegenerateReadingMaterialBody', adminRegenerateReadingMaterialBody)
            const localVarPath = `/admin/skill/{skill_id}/reading-material/regenerate`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminRegenerateReadingMaterialBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} sessionId 
         * @param {AttemptQuestionBody} attemptQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAttemptGuidedQuestion: async (questionId: string, sessionId: string, attemptQuestionBody: AttemptQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('skillApiAttemptGuidedQuestion', 'questionId', questionId)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('skillApiAttemptGuidedQuestion', 'sessionId', sessionId)
            // verify required parameter 'attemptQuestionBody' is not null or undefined
            assertParamExists('skillApiAttemptGuidedQuestion', 'attemptQuestionBody', attemptQuestionBody)
            const localVarPath = `/course/session/{session_id}/question/{question_id}/attempt`
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attemptQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} sessionId 
         * @param {AttemptQuestionBody} attemptQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAttemptTopicTestQuestion: async (questionId: string, sessionId: string, attemptQuestionBody: AttemptQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('skillApiAttemptTopicTestQuestion', 'questionId', questionId)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('skillApiAttemptTopicTestQuestion', 'sessionId', sessionId)
            // verify required parameter 'attemptQuestionBody' is not null or undefined
            assertParamExists('skillApiAttemptTopicTestQuestion', 'attemptQuestionBody', attemptQuestionBody)
            const localVarPath = `/course/topic-session/{session_id}/question/{question_id}/attempt`
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attemptQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The same sweep the cron runs. Exposed because beat only fires in PROD, so this is the only way to exercise it anywhere else — and `dry_run` answers \"which live courses are hollow right now\" without spending anything.
         * @summary Build the opening lessons of any live course still missing them.
         * @param {OpeningBackfillBody} openingBackfillBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiBackfillLiveCourseOpenings: async (openingBackfillBody: OpeningBackfillBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'openingBackfillBody' is not null or undefined
            assertParamExists('skillApiBackfillLiveCourseOpenings', 'openingBackfillBody', openingBackfillBody)
            const localVarPath = `/admin/course-build/opening-backfill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(openingBackfillBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NameList} nameList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiBulkCreateDomainsRoute: async (nameList: NameList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nameList' is not null or undefined
            assertParamExists('skillApiBulkCreateDomainsRoute', 'nameList', nameList)
            const localVarPath = `/admin/skill/bulk_create_domains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nameList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IDNames} iDNames 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiBulkCreateModulesRoute: async (iDNames: IDNames, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iDNames' is not null or undefined
            assertParamExists('skillApiBulkCreateModulesRoute', 'iDNames', iDNames)
            const localVarPath = `/admin/skill/bulk_create_modules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDNames, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTopicsSubtopicsBody} createTopicsSubtopicsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiBulkCreateTopicSubtopicRoute: async (createTopicsSubtopicsBody: CreateTopicsSubtopicsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTopicsSubtopicsBody' is not null or undefined
            assertParamExists('skillApiBulkCreateTopicSubtopicRoute', 'createTopicsSubtopicsBody', createTopicsSubtopicsBody)
            const localVarPath = `/admin/skill/bulk_create_topic_subtopic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTopicsSubtopicsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCancelCourseBuildJob: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('skillApiCancelCourseBuildJob', 'jobId', jobId)
            const localVarPath = `/admin/course-build/{job_id}/cancel`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} promotionId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCancelCoursePromotion: async (promotionId: string, skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promotionId' is not null or undefined
            assertParamExists('skillApiCancelCoursePromotion', 'promotionId', promotionId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiCancelCoursePromotion', 'skillId', skillId)
            const localVarPath = `/admin/courses/{skill_id}/promotion/{promotion_id}/cancel`
                .replace('{promotion_id}', encodeURIComponent(String(promotionId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} alias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCheckSkillAliasAvailability: async (alias: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alias' is not null or undefined
            assertParamExists('skillApiCheckSkillAliasAvailability', 'alias', alias)
            const localVarPath = `/admin/skill/alias/{alias}/is-available`
                .replace('{alias}', encodeURIComponent(String(alias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCloseTopicJump: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('skillApiCloseTopicJump', 'sessionId', sessionId)
            const localVarPath = `/course/topic-jump/{session_id}/close`
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCloseTopicTestSession: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('skillApiCloseTopicTestSession', 'sessionId', sessionId)
            const localVarPath = `/course/topic-session/{session_id}/close`
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} labelId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCompleteGuidedLabel: async (labelId: string, skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('skillApiCompleteGuidedLabel', 'labelId', labelId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiCompleteGuidedLabel', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/label/{label_id}/complete`
                .replace('{label_id}', encodeURIComponent(String(labelId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nodeId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCompleteIntro: async (nodeId: string, skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('skillApiCompleteIntro', 'nodeId', nodeId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiCompleteIntro', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/intro/{node_id}/complete`
                .replace('{node_id}', encodeURIComponent(String(nodeId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiContinueCourseBuildJob: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('skillApiContinueCourseBuildJob', 'jobId', jobId)
            const localVarPath = `/admin/course-build/{job_id}/continue`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiContinueStalledCourseBuildJobs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/course-build/continue-stalled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCourseBuildReadiness: async (moduleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('skillApiCourseBuildReadiness', 'moduleId', moduleId)
            const localVarPath = `/admin/skill/{module_id}/course-build/readiness`
                .replace('{module_id}', encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {CreateCoursePromotionBody} createCoursePromotionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCreateCoursePromotion: async (skillId: string, createCoursePromotionBody: CreateCoursePromotionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiCreateCoursePromotion', 'skillId', skillId)
            // verify required parameter 'createCoursePromotionBody' is not null or undefined
            assertParamExists('skillApiCreateCoursePromotion', 'createCoursePromotionBody', createCoursePromotionBody)
            const localVarPath = `/admin/courses/{skill_id}/promotion`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCoursePromotionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpsertSkillFAQBody} upsertSkillFAQBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCreateSkillFaq: async (skillId: string, upsertSkillFAQBody: UpsertSkillFAQBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiCreateSkillFaq', 'skillId', skillId)
            // verify required parameter 'upsertSkillFAQBody' is not null or undefined
            assertParamExists('skillApiCreateSkillFaq', 'upsertSkillFAQBody', upsertSkillFAQBody)
            const localVarPath = `/admin/skill/{skill_id}/faq`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSkillFAQBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {CreateSkillReviewBody} createSkillReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCreateSkillReview: async (skillId: string, createSkillReviewBody: CreateSkillReviewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiCreateSkillReview', 'skillId', skillId)
            // verify required parameter 'createSkillReviewBody' is not null or undefined
            assertParamExists('skillApiCreateSkillReview', 'createSkillReviewBody', createSkillReviewBody)
            const localVarPath = `/admin/skill/{skill_id}/review`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSkillReviewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertSkillSeriesBody} upsertSkillSeriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCreateSkillSeries: async (upsertSkillSeriesBody: UpsertSkillSeriesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertSkillSeriesBody' is not null or undefined
            assertParamExists('skillApiCreateSkillSeries', 'upsertSkillSeriesBody', upsertSkillSeriesBody)
            const localVarPath = `/admin/skill-series`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSkillSeriesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} confirmName 
         * @param {string} skillId 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDeleteCourse: async (confirmName: string, skillId: string, dryRun?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'confirmName' is not null or undefined
            assertParamExists('skillApiDeleteCourse', 'confirmName', confirmName)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiDeleteCourse', 'skillId', skillId)
            const localVarPath = `/admin/courses/{skill_id}`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (confirmName !== undefined) {
                localVarQueryParameter['confirm_name'] = confirmName;
            }

            if (dryRun !== undefined) {
                localVarQueryParameter['dry_run'] = dryRun;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDeleteCourseReview: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiDeleteCourseReview', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/review`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} faqId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDeleteSkillFaq: async (faqId: string, skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'faqId' is not null or undefined
            assertParamExists('skillApiDeleteSkillFaq', 'faqId', faqId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiDeleteSkillFaq', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/faq/{faq_id}`
                .replace('{faq_id}', encodeURIComponent(String(faqId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} reviewId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDeleteSkillReview: async (reviewId: string, skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewId' is not null or undefined
            assertParamExists('skillApiDeleteSkillReview', 'reviewId', reviewId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiDeleteSkillReview', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/review/{review_id}`
                .replace('{review_id}', encodeURIComponent(String(reviewId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDeleteSkillSeries: async (seriesId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesId' is not null or undefined
            assertParamExists('skillApiDeleteSkillSeries', 'seriesId', seriesId)
            const localVarPath = `/admin/skill-series/{series_id}`
                .replace('{series_id}', encodeURIComponent(String(seriesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {DismissCourseReviewBody} dismissCourseReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDismissCourseReview: async (skillId: string, dismissCourseReviewBody: DismissCourseReviewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiDismissCourseReview', 'skillId', skillId)
            // verify required parameter 'dismissCourseReviewBody' is not null or undefined
            assertParamExists('skillApiDismissCourseReview', 'dismissCourseReviewBody', dismissCourseReviewBody)
            const localVarPath = `/course/{skill_id}/review/dismiss`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dismissCourseReviewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDismissProgressResetNotice: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiDismissProgressResetNotice', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/progress-reset-notice/dismiss`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDownloadGuidedCourseCertificate: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiDownloadGuidedCourseCertificate', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/certificate/download`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {number | null} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDownloadSkillQuestions: async (skillId: string, limit?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiDownloadSkillQuestions', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/questions/download`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiEnrollGuidedCourse: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiEnrollGuidedCourse', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/enroll`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * entry point the learner flow will call when it reaches an unbuilt label.
         * @summary Build a single label on demand. Admin-facing for now; this is the same
         * @param {string} labelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiEnsureLabelBuilt: async (labelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('skillApiEnsureLabelBuilt', 'labelId', labelId)
            const localVarPath = `/admin/skill/{label_id}/course-build/ensure`
                .replace('{label_id}', encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {string | null} [contentModel] 
         * @param {number | null} [labelLimit] 
         * @param {string | null} [questionModel] 
         * @param {number | null} [questionsPerLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiEstimateCourseBuild: async (moduleId: string, contentModel?: string | null, labelLimit?: number | null, questionModel?: string | null, questionsPerLabel?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('skillApiEstimateCourseBuild', 'moduleId', moduleId)
            const localVarPath = `/admin/skill/{module_id}/course-build/estimate`
                .replace('{module_id}', encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (contentModel !== undefined) {
                localVarQueryParameter['content_model'] = contentModel;
            }

            if (labelLimit !== undefined) {
                localVarQueryParameter['label_limit'] = labelLimit;
            }

            if (questionModel !== undefined) {
                localVarQueryParameter['question_model'] = questionModel;
            }

            if (questionsPerLabel !== undefined) {
                localVarQueryParameter['questions_per_label'] = questionsPerLabel;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {GenerateCodingQuestionsBody} generateCodingQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGenerateCodingQuestions: async (skillId: string, generateCodingQuestionsBody: GenerateCodingQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGenerateCodingQuestions', 'skillId', skillId)
            // verify required parameter 'generateCodingQuestionsBody' is not null or undefined
            assertParamExists('skillApiGenerateCodingQuestions', 'generateCodingQuestionsBody', generateCodingQuestionsBody)
            const localVarPath = `/admin/skill/{skill_id}/generate-coding-questions`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateCodingQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGenerateGuidedCourseCertificate: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGenerateGuidedCourseCertificate', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/certificate/generate`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGenerateImageDensitySample: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGenerateImageDensitySample', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/image-density/generate-sample`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {GenerateImageOnlyQuestionsBody} generateImageOnlyQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGenerateImageOnlyQuestions: async (skillId: string, generateImageOnlyQuestionsBody: GenerateImageOnlyQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGenerateImageOnlyQuestions', 'skillId', skillId)
            // verify required parameter 'generateImageOnlyQuestionsBody' is not null or undefined
            assertParamExists('skillApiGenerateImageOnlyQuestions', 'generateImageOnlyQuestionsBody', generateImageOnlyQuestionsBody)
            const localVarPath = `/admin/skill/{skill_id}/generate-image-questions`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateImageOnlyQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [maxDate] 
         * @param {string} [minDate] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {string | null} [skillId] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortOrder] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetAdminSkillAnalytics: async (maxDate?: string, minDate?: string, pageNo?: number, pageSize?: number, searchQuery?: string, skillId?: string | null, sortBy?: string | null, sortOrder?: string | null, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/skill/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (maxDate !== undefined) {
                localVarQueryParameter['max_date'] = maxDate;
            }

            if (minDate !== undefined) {
                localVarQueryParameter['min_date'] = minDate;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (skillId !== undefined) {
                localVarQueryParameter['skill_id'] = skillId;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillType 
         * @param {boolean | null} [hasUnmapped] 
         * @param {boolean | null} [isCurrentlyGenerating] 
         * @param {boolean | null} [isGuidedCourse] 
         * @param {boolean | null} [isPublicListed] 
         * @param {boolean | null} [isSkillTreeAvailable] 
         * @param {number | null} [maxMappedCount] 
         * @param {number | null} [maxQuestionCount] 
         * @param {number | null} [minMappedCount] 
         * @param {number | null} [minQuestionCount] 
         * @param {boolean | null} [missingIcon] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [parentSkillId] 
         * @param {string} [searchText] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortOrder] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetAdminSkillListBySkillType: async (skillType: string, hasUnmapped?: boolean | null, isCurrentlyGenerating?: boolean | null, isGuidedCourse?: boolean | null, isPublicListed?: boolean | null, isSkillTreeAvailable?: boolean | null, maxMappedCount?: number | null, maxQuestionCount?: number | null, minMappedCount?: number | null, minQuestionCount?: number | null, missingIcon?: boolean | null, pageNo?: number, pageSize?: number, parentSkillId?: string | null, searchText?: string, sortBy?: string | null, sortOrder?: string | null, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillType' is not null or undefined
            assertParamExists('skillApiGetAdminSkillListBySkillType', 'skillType', skillType)
            const localVarPath = `/admin/skill/{skill_type}`
                .replace('{skill_type}', encodeURIComponent(String(skillType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (hasUnmapped !== undefined) {
                localVarQueryParameter['has_unmapped'] = hasUnmapped;
            }

            if (isCurrentlyGenerating !== undefined) {
                localVarQueryParameter['is_currently_generating'] = isCurrentlyGenerating;
            }

            if (isGuidedCourse !== undefined) {
                localVarQueryParameter['is_guided_course'] = isGuidedCourse;
            }

            if (isPublicListed !== undefined) {
                localVarQueryParameter['is_public_listed'] = isPublicListed;
            }

            if (isSkillTreeAvailable !== undefined) {
                localVarQueryParameter['is_skill_tree_available'] = isSkillTreeAvailable;
            }

            if (maxMappedCount !== undefined) {
                localVarQueryParameter['max_mapped_count'] = maxMappedCount;
            }

            if (maxQuestionCount !== undefined) {
                localVarQueryParameter['max_question_count'] = maxQuestionCount;
            }

            if (minMappedCount !== undefined) {
                localVarQueryParameter['min_mapped_count'] = minMappedCount;
            }

            if (minQuestionCount !== undefined) {
                localVarQueryParameter['min_question_count'] = minQuestionCount;
            }

            if (missingIcon !== undefined) {
                localVarQueryParameter['missing_icon'] = missingIcon;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (parentSkillId !== undefined) {
                localVarQueryParameter['parent_skill_id'] = parentSkillId;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['search_text'] = searchText;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCoreSkillDetail: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetCoreSkillDetail', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/core-detail`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCoreSkillDuplicates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/skill/core-duplicates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SkillApiGetCoreSkillGapsViewEnum} [view] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCoreSkillGaps: async (view?: SkillApiGetCoreSkillGapsViewEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/skill/core-gaps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (view !== undefined) {
                localVarQueryParameter['view'] = view;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * dict — Flask\'s JSON provider sorts object keys and would scramble it).
         * @summary The module\'s saved hierarchy in true teaching order (ordered list, not a
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCourseBuildHierarchy: async (moduleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('skillApiGetCourseBuildHierarchy', 'moduleId', moduleId)
            const localVarPath = `/admin/skill/{module_id}/course-build/hierarchy`
                .replace('{module_id}', encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCourseBuildJob: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('skillApiGetCourseBuildJob', 'jobId', jobId)
            const localVarPath = `/admin/course-build/{job_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCourseImageQuestions: async (moduleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('skillApiGetCourseImageQuestions', 'moduleId', moduleId)
            const localVarPath = `/admin/skill/{module_id}/image-questions`
                .replace('{module_id}', encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCoursePromotion: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetCoursePromotion', 'skillId', skillId)
            const localVarPath = `/admin/courses/{skill_id}/promotion`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCourseCertificate: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetGuidedCourseCertificate', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/certificate`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCourseInfo: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetGuidedCourseInfo', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/info`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCourseMap: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetGuidedCourseMap', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/map`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCourseProgress: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetGuidedCourseProgress', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/progress`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCourseRelevance: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/skill/guided-courses/relevance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [forceRefresh] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCourses: async (forceRefresh?: boolean, limit?: number | null, offset?: number | null, q?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/skill/guided-courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (forceRefresh !== undefined) {
                localVarQueryParameter['force_refresh'] = forceRefresh;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCoursesProgress: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/skill/guided-courses/progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCurrentQuestion: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('skillApiGetGuidedCurrentQuestion', 'sessionId', sessionId)
            const localVarPath = `/course/session/{session_id}/current-question`
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedSessionProgress: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('skillApiGetGuidedSessionProgress', 'sessionId', sessionId)
            const localVarPath = `/course/session/{session_id}/progress`
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nodeId 
         * @param {string} skillId 
         * @param {boolean} [forceWelcome] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetIntroContent: async (nodeId: string, skillId: string, forceWelcome?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('skillApiGetIntroContent', 'nodeId', nodeId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetIntroContent', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/intro/{node_id}/content`
                .replace('{node_id}', encodeURIComponent(String(nodeId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (forceWelcome !== undefined) {
                localVarQueryParameter['force_welcome'] = forceWelcome;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Polled by the lesson loader. Also starts the build when nothing is running, so a lesson whose build died recovers without the learner doing anything — except right after one gave up, which needs `force` (the retry button).
         * @summary Progress of the lesson the learner is waiting on.
         * @param {string} labelId 
         * @param {string} skillId 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetLabelBuildStatus: async (labelId: string, skillId: string, force?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('skillApiGetLabelBuildStatus', 'labelId', labelId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetLabelBuildStatus', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/label/{label_id}/build-status`
                .replace('{label_id}', encodeURIComponent(String(labelId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} labelId 
         * @param {string} skillId 
         * @param {boolean} [supportsBuilding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetLabelContent: async (labelId: string, skillId: string, supportsBuilding?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('skillApiGetLabelContent', 'labelId', labelId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetLabelContent', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/label/{label_id}/content`
                .replace('{label_id}', encodeURIComponent(String(labelId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supportsBuilding !== undefined) {
                localVarQueryParameter['supports_building'] = supportsBuilding;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetModulePublishStatus: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetModulePublishStatus', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/publish-status`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetPublicSeriesList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/series`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} aliasOrId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetPublicSkillDetail: async (aliasOrId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aliasOrId' is not null or undefined
            assertParamExists('skillApiGetPublicSkillDetail', 'aliasOrId', aliasOrId)
            const localVarPath = `/public/skill/{alias_or_id}`
                .replace('{alias_or_id}', encodeURIComponent(String(aliasOrId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string> | null} [categories] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetPublicSkillsHub: async (categories?: Array<string> | null, limit?: number | null, offset?: number | null, q?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categories) {
                localVarQueryParameter['categories'] = categories;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetPublicSkillsList: async (pageNo?: number, pageSize?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/skill/public-skills-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetQuestionCreationSkillList: async (page?: number, pageSize?: number, searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/skill/question-creation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetReadingMaterial: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetReadingMaterial', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/reading-material`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillBadges: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillBadges', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/badges`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} category 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillBrowse: async (category: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('skillApiGetSkillBrowse', 'category', category)
            const localVarPath = `/v2/skill/browse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillBuilderCertificate: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillBuilderCertificate', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/certificate`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillBuilderCertificateProgress: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillBuilderCertificateProgress', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/certificate-progress`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillByIdV2: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillByIdV2', 'skillId', skillId)
            const localVarPath = `/v2/skill/{skill_id}`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillCategories: async (limit?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/skill/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillContent: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillContent', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/content`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillCostEstimate: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillCostEstimate', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/cost-estimate`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillDashboardSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/skill/dashboard-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This skill\'s AI-generation guidance plus what it inherits from ancestors.
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillGenerationPrompt: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillGenerationPrompt', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/generation-prompt`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillList: async (page?: number, pageSize?: number, searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/skill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [coreOnly] 
         * @param {string} [searchQuery] 
         * @param {string} [searchType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillListV2: async (coreOnly?: boolean, searchQuery?: string, searchType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/skill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (coreOnly !== undefined) {
                localVarQueryParameter['core_only'] = coreOnly;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (searchType !== undefined) {
                localVarQueryParameter['search_type'] = searchType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [domain] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortOrder] 
         * @param {string | null} [step] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillModuleTodos: async (domain?: string | null, pageNo?: number, pageSize?: number, searchText?: string, sortBy?: string | null, sortOrder?: string | null, step?: string | null, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/skill/module-todos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['search_text'] = searchText;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {string | null} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillPercentile: async (skillId: string, username?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillPercentile', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/percentile`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillPreference: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillPreference', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/preference`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillPublishReadiness: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillPublishReadiness', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/publish-readiness`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillRelatedCourses: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillRelatedCourses', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/courses`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {string | null} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillReport: async (skillId: string, username?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillReport', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/report`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillStartStatistics: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillStartStatistics', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/start-statistics`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillTree: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetSkillTree', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/hierarchy`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {number | null} [cardIndex] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetTheoryAiChats: async (skillId: string, cardIndex?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetTheoryAiChats', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/theory-ai-chats`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cardIndex !== undefined) {
                localVarQueryParameter['card_index'] = cardIndex;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetTopicJumpResult: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('skillApiGetTopicJumpResult', 'sessionId', sessionId)
            const localVarPath = `/course/topic-jump/{session_id}/result`
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {string | null} [questionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetTopicTestCurrentQuestion: async (sessionId: string, questionId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('skillApiGetTopicTestCurrentQuestion', 'sessionId', sessionId)
            const localVarPath = `/course/topic-session/{session_id}/current-question`
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (questionId !== undefined) {
                localVarQueryParameter['question_id'] = questionId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetTopicTestProgress: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('skillApiGetTopicTestProgress', 'sessionId', sessionId)
            const localVarPath = `/course/topic-session/{session_id}/progress`
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetTopicTestResult: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('skillApiGetTopicTestResult', 'sessionId', sessionId)
            const localVarPath = `/course/topic-session/{session_id}/result`
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetUserSkillDetails: async (skillId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiGetUserSkillDetails', 'skillId', skillId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('skillApiGetUserSkillDetails', 'userId', userId)
            const localVarPath = `/skill/{skill_id}/user/{user_id}`
                .replace('{skill_id}', encodeURIComponent(String(skillId)))
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {SkillApiListAdminCourseFeedbackScopeEnum} [scope] 
         * @param {Array<string>} [skillIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListAdminCourseFeedback: async (page?: number, pageSize?: number, scope?: SkillApiListAdminCourseFeedbackScopeEnum, skillIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/course-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids'] = skillIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [pricing] 
         * @param {string | null} [q] 
         * @param {SkillApiListAdminCoursesRefreshedEnum} [refreshed] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListAdminCourses: async (page?: number, pageSize?: number, pricing?: string, q?: string | null, refreshed?: SkillApiListAdminCoursesRefreshedEnum, sortBy?: string, sortOrder?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (pricing !== undefined) {
                localVarQueryParameter['pricing'] = pricing;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (refreshed !== undefined) {
                localVarQueryParameter['refreshed'] = refreshed;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [moduleId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListCourseBuildJobs: async (moduleId?: string | null, page?: number, pageSize?: number, status?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/course-build`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (moduleId !== undefined) {
                localVarQueryParameter['module_id'] = moduleId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListCoursePromotions: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiListCoursePromotions', 'skillId', skillId)
            const localVarPath = `/admin/courses/{skill_id}/promotions`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListSeriesCourses: async (seriesId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesId' is not null or undefined
            assertParamExists('skillApiListSeriesCourses', 'seriesId', seriesId)
            const localVarPath = `/admin/skill-series/{series_id}/courses`
                .replace('{series_id}', encodeURIComponent(String(seriesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListSkillFaqs: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiListSkillFaqs', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/faq`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {boolean | null} [isFeatured] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [source] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListSkillReviews: async (skillId: string, isFeatured?: boolean | null, pageNo?: number, pageSize?: number, source?: string | null, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiListSkillReviews', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/review`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isFeatured !== undefined) {
                localVarQueryParameter['is_featured'] = isFeatured;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean | null} [isPublicListed] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListSkillSeries: async (isPublicListed?: boolean | null, pageNo?: number, pageSize?: number, searchQuery?: string | null, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/skill-series`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isPublicListed !== undefined) {
                localVarQueryParameter['is_public_listed'] = isPublicListed;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [dryRun] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiMergeDuplicatesByName: async (dryRun?: boolean, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/skill/merge-duplicate-skills-by-name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dryRun !== undefined) {
                localVarQueryParameter['dry_run'] = dryRun;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {PreviewCoursePromotionBody} previewCoursePromotionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiPreviewCoursePromotion: async (skillId: string, previewCoursePromotionBody: PreviewCoursePromotionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiPreviewCoursePromotion', 'skillId', skillId)
            // verify required parameter 'previewCoursePromotionBody' is not null or undefined
            assertParamExists('skillApiPreviewCoursePromotion', 'previewCoursePromotionBody', previewCoursePromotionBody)
            const localVarPath = `/admin/courses/{skill_id}/promotion/preview`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewCoursePromotionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PruneOrphanSkillsBody} pruneOrphanSkillsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiPruneOrphanSkills: async (pruneOrphanSkillsBody: PruneOrphanSkillsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pruneOrphanSkillsBody' is not null or undefined
            assertParamExists('skillApiPruneOrphanSkills', 'pruneOrphanSkillsBody', pruneOrphanSkillsBody)
            const localVarPath = `/admin/skills/prune-orphans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pruneOrphanSkillsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {PublishModuleBody} publishModuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiPublishModule: async (skillId: string, publishModuleBody: PublishModuleBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiPublishModule', 'skillId', skillId)
            // verify required parameter 'publishModuleBody' is not null or undefined
            assertParamExists('skillApiPublishModule', 'publishModuleBody', publishModuleBody)
            const localVarPath = `/admin/skill/{skill_id}/publish`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishModuleBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiPurchaseGuidedCourse: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiPurchaseGuidedCourse', 'skillId', skillId)
            const localVarPath = `/course/{skill_id}/purchase`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set the label\'s generation-prompt first — a rebuild with no guidance regenerates the same lesson from the same inputs.
         * @summary Replace a lesson: retire its questions, rewrite its cards, rebuild both.
         * @param {string} labelId 
         * @param {RebuildLabelBody} rebuildLabelBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRebuildLabel: async (labelId: string, rebuildLabelBody: RebuildLabelBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('skillApiRebuildLabel', 'labelId', labelId)
            // verify required parameter 'rebuildLabelBody' is not null or undefined
            assertParamExists('skillApiRebuildLabel', 'rebuildLabelBody', rebuildLabelBody)
            const localVarPath = `/admin/skill/{label_id}/lesson/rebuild`
                .replace('{label_id}', encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rebuildLabelBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRecomputeCoreSkills: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/skill/recompute-core-skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRecomputeSkillImageDensity: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiRecomputeSkillImageDensity', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/image-density/recompute`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRecomputeSkillQuality: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiRecomputeSkillQuality', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/quality/recompute`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRefillHearts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/skill/refill-hearts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRemoveSeriesCourse: async (seriesId: string, skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesId' is not null or undefined
            assertParamExists('skillApiRemoveSeriesCourse', 'seriesId', seriesId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiRemoveSeriesCourse', 'skillId', skillId)
            const localVarPath = `/admin/skill-series/{series_id}/courses/{skill_id}`
                .replace('{series_id}', encodeURIComponent(String(seriesId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRenameSkill: async (name: string, skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('skillApiRenameSkill', 'name', name)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiRenameSkill', 'skillId', skillId)
            const localVarPath = `/admin/skill/rename/{skill_id}`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesId 
         * @param {ReorderSeriesBody} reorderSeriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiReorderSeriesCourses: async (seriesId: string, reorderSeriesBody: ReorderSeriesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesId' is not null or undefined
            assertParamExists('skillApiReorderSeriesCourses', 'seriesId', seriesId)
            // verify required parameter 'reorderSeriesBody' is not null or undefined
            assertParamExists('skillApiReorderSeriesCourses', 'reorderSeriesBody', reorderSeriesBody)
            const localVarPath = `/admin/skill-series/{series_id}/order`
                .replace('{series_id}', encodeURIComponent(String(seriesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderSeriesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiResetSkillPublicContent: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiResetSkillPublicContent', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/public-content`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {ResolveCoreSkillReviewBody} resolveCoreSkillReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiResolveCoreSkillReview: async (skillId: string, resolveCoreSkillReviewBody: ResolveCoreSkillReviewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiResolveCoreSkillReview', 'skillId', skillId)
            // verify required parameter 'resolveCoreSkillReviewBody' is not null or undefined
            assertParamExists('skillApiResolveCoreSkillReview', 'resolveCoreSkillReviewBody', resolveCoreSkillReviewBody)
            const localVarPath = `/admin/skill/{skill_id}/core-review`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveCoreSkillReviewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} labelTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRetryCourseBuildLabel: async (labelTaskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'labelTaskId' is not null or undefined
            assertParamExists('skillApiRetryCourseBuildLabel', 'labelTaskId', labelTaskId)
            const localVarPath = `/admin/course-build/label/{label_task_id}/retry`
                .replace('{label_task_id}', encodeURIComponent(String(labelTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReviewCoreSkillsBody} reviewCoreSkillsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiReviewCoreSkills: async (reviewCoreSkillsBody: ReviewCoreSkillsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewCoreSkillsBody' is not null or undefined
            assertParamExists('skillApiReviewCoreSkills', 'reviewCoreSkillsBody', reviewCoreSkillsBody)
            const localVarPath = `/admin/skill/core-review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewCoreSkillsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The from-scratch wizard uses this so the admin can see the improved order (and why it is better) before committing — nothing is persisted here.
         * @summary Pedagogical order review for a hierarchy that has not been saved yet.
         * @param {ReviewHierarchyOrderBody} reviewHierarchyOrderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiReviewHierarchyOrder: async (reviewHierarchyOrderBody: ReviewHierarchyOrderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewHierarchyOrderBody' is not null or undefined
            assertParamExists('skillApiReviewHierarchyOrder', 'reviewHierarchyOrderBody', reviewHierarchyOrderBody)
            const localVarPath = `/admin/course-build/hierarchy/review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewHierarchyOrderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSaveMyStreak: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiSaveMyStreak', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/save-my-streak`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {CoursePromotionTestEmailBody} coursePromotionTestEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSendCoursePromotionTestEmail: async (skillId: string, coursePromotionTestEmailBody: CoursePromotionTestEmailBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiSendCoursePromotionTestEmail', 'skillId', skillId)
            // verify required parameter 'coursePromotionTestEmailBody' is not null or undefined
            assertParamExists('skillApiSendCoursePromotionTestEmail', 'coursePromotionTestEmailBody', coursePromotionTestEmailBody)
            const localVarPath = `/admin/courses/{skill_id}/promotion/test-email`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coursePromotionTestEmailBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {SetCoreSkillExclusionBody} setCoreSkillExclusionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSetCoreSkillExclusion: async (skillId: string, setCoreSkillExclusionBody: SetCoreSkillExclusionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiSetCoreSkillExclusion', 'skillId', skillId)
            // verify required parameter 'setCoreSkillExclusionBody' is not null or undefined
            assertParamExists('skillApiSetCoreSkillExclusion', 'setCoreSkillExclusionBody', setCoreSkillExclusionBody)
            const localVarPath = `/admin/skill/{skill_id}/core-exclusion`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCoreSkillExclusionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {SetCourseIntroVisibilityBody} setCourseIntroVisibilityBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSetCourseIntroVisibility: async (skillId: string, setCourseIntroVisibilityBody: SetCourseIntroVisibilityBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiSetCourseIntroVisibility', 'skillId', skillId)
            // verify required parameter 'setCourseIntroVisibilityBody' is not null or undefined
            assertParamExists('skillApiSetCourseIntroVisibility', 'setCourseIntroVisibilityBody', setCourseIntroVisibilityBody)
            const localVarPath = `/admin/courses/{skill_id}/intro-visibility`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCourseIntroVisibilityBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {SetCoursePricingBody} setCoursePricingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSetCoursePricing: async (skillId: string, setCoursePricingBody: SetCoursePricingBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiSetCoursePricing', 'skillId', skillId)
            // verify required parameter 'setCoursePricingBody' is not null or undefined
            assertParamExists('skillApiSetCoursePricing', 'setCoursePricingBody', setCoursePricingBody)
            const localVarPath = `/admin/courses/{skill_id}/pricing`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCoursePricingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Takes effect the next time that part of the tree is generated — writing it regenerates nothing on its own.
         * @summary Set or clear generation guidance on any level (Module/Topic/SubTopic/Label).
         * @param {string} skillId 
         * @param {SetSkillGenerationPromptBody} setSkillGenerationPromptBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSetSkillGenerationPrompt: async (skillId: string, setSkillGenerationPromptBody: SetSkillGenerationPromptBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiSetSkillGenerationPrompt', 'skillId', skillId)
            // verify required parameter 'setSkillGenerationPromptBody' is not null or undefined
            assertParamExists('skillApiSetSkillGenerationPrompt', 'setSkillGenerationPromptBody', setSkillGenerationPromptBody)
            const localVarPath = `/admin/skill/{skill_id}/generation-prompt`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setSkillGenerationPromptBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {IDList} iDList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSetSkillPreference: async (skillId: string, iDList: IDList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiSetSkillPreference', 'skillId', skillId)
            // verify required parameter 'iDList' is not null or undefined
            assertParamExists('skillApiSetSkillPreference', 'iDList', iDList)
            const localVarPath = `/skill/{skill_id}/preference`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {PublicListingBody} publicListingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSetSkillPublicListing: async (skillId: string, publicListingBody: PublicListingBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiSetSkillPublicListing', 'skillId', skillId)
            // verify required parameter 'publicListingBody' is not null or undefined
            assertParamExists('skillApiSetSkillPublicListing', 'publicListingBody', publicListingBody)
            const localVarPath = `/admin/skill/{skill_id}/public-listing`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publicListingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSkillAiAssistantUnlock: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiSkillAiAssistantUnlock', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/ai-assistant/unlock`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {StartCourseBuildBody} startCourseBuildBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiStartCourseBuild: async (moduleId: string, startCourseBuildBody: StartCourseBuildBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('skillApiStartCourseBuild', 'moduleId', moduleId)
            // verify required parameter 'startCourseBuildBody' is not null or undefined
            assertParamExists('skillApiStartCourseBuild', 'startCourseBuildBody', startCourseBuildBody)
            const localVarPath = `/admin/skill/{module_id}/course-build`
                .replace('{module_id}', encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCourseBuildBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} labelId 
         * @param {string} skillId 
         * @param {StartGuidedLabelSessionBody} startGuidedLabelSessionBody 
         * @param {boolean} [supportsBuilding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiStartGuidedLabelSession: async (labelId: string, skillId: string, startGuidedLabelSessionBody: StartGuidedLabelSessionBody, supportsBuilding?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('skillApiStartGuidedLabelSession', 'labelId', labelId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiStartGuidedLabelSession', 'skillId', skillId)
            // verify required parameter 'startGuidedLabelSessionBody' is not null or undefined
            assertParamExists('skillApiStartGuidedLabelSession', 'startGuidedLabelSessionBody', startGuidedLabelSessionBody)
            const localVarPath = `/course/{skill_id}/label/{label_id}/session/start`
                .replace('{label_id}', encodeURIComponent(String(labelId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supportsBuilding !== undefined) {
                localVarQueryParameter['supports_building'] = supportsBuilding;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startGuidedLabelSessionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {string} topicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiStartGuidedTopicSession: async (skillId: string, topicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiStartGuidedTopicSession', 'skillId', skillId)
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('skillApiStartGuidedTopicSession', 'topicId', topicId)
            const localVarPath = `/course/{skill_id}/topic/{topic_id}/session/start`
                .replace('{skill_id}', encodeURIComponent(String(skillId)))
                .replace('{topic_id}', encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {string} topicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiStartTopicJump: async (skillId: string, topicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiStartTopicJump', 'skillId', skillId)
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('skillApiStartTopicJump', 'topicId', topicId)
            const localVarPath = `/course/{skill_id}/topic/{topic_id}/jump/start`
                .replace('{skill_id}', encodeURIComponent(String(skillId)))
                .replace('{topic_id}', encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {SubmitCourseFeedbackBody} submitCourseFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSubmitCourseFeedback: async (skillId: string, submitCourseFeedbackBody: SubmitCourseFeedbackBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiSubmitCourseFeedback', 'skillId', skillId)
            // verify required parameter 'submitCourseFeedbackBody' is not null or undefined
            assertParamExists('skillApiSubmitCourseFeedback', 'submitCourseFeedbackBody', submitCourseFeedbackBody)
            const localVarPath = `/course/{skill_id}/feedback`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitCourseFeedbackBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {SubmitCourseReviewBody} submitCourseReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSubmitCourseReview: async (skillId: string, submitCourseReviewBody: SubmitCourseReviewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiSubmitCourseReview', 'skillId', skillId)
            // verify required parameter 'submitCourseReviewBody' is not null or undefined
            assertParamExists('skillApiSubmitCourseReview', 'submitCourseReviewBody', submitCourseReviewBody)
            const localVarPath = `/course/{skill_id}/review`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitCourseReviewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {TheoryAIChatBody} theoryAIChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiTheoryAiChat: async (skillId: string, theoryAIChatBody: TheoryAIChatBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiTheoryAiChat', 'skillId', skillId)
            // verify required parameter 'theoryAIChatBody' is not null or undefined
            assertParamExists('skillApiTheoryAiChat', 'theoryAIChatBody', theoryAIChatBody)
            const localVarPath = `/skill/{skill_id}/theory-ai-chat`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(theoryAIChatBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {ToggleGuidedCourseBody} toggleGuidedCourseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiToggleGuidedCourse: async (skillId: string, toggleGuidedCourseBody: ToggleGuidedCourseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiToggleGuidedCourse', 'skillId', skillId)
            // verify required parameter 'toggleGuidedCourseBody' is not null or undefined
            assertParamExists('skillApiToggleGuidedCourse', 'toggleGuidedCourseBody', toggleGuidedCourseBody)
            const localVarPath = `/admin/skill/{skill_id}/guided-course/toggle`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleGuidedCourseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpdateAllowImagesBody} updateAllowImagesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpdateSkillAllowImages: async (skillId: string, updateAllowImagesBody: UpdateAllowImagesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiUpdateSkillAllowImages', 'skillId', skillId)
            // verify required parameter 'updateAllowImagesBody' is not null or undefined
            assertParamExists('skillApiUpdateSkillAllowImages', 'updateAllowImagesBody', updateAllowImagesBody)
            const localVarPath = `/admin/skill/{skill_id}/allow-images`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAllowImagesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpdateSkillCategoriesBody} updateSkillCategoriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpdateSkillCategories: async (skillId: string, updateSkillCategoriesBody: UpdateSkillCategoriesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiUpdateSkillCategories', 'skillId', skillId)
            // verify required parameter 'updateSkillCategoriesBody' is not null or undefined
            assertParamExists('skillApiUpdateSkillCategories', 'updateSkillCategoriesBody', updateSkillCategoriesBody)
            const localVarPath = `/admin/skill/{skill_id}/categories`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSkillCategoriesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} faqId 
         * @param {string} skillId 
         * @param {UpsertSkillFAQBody} upsertSkillFAQBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpdateSkillFaq: async (faqId: string, skillId: string, upsertSkillFAQBody: UpsertSkillFAQBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'faqId' is not null or undefined
            assertParamExists('skillApiUpdateSkillFaq', 'faqId', faqId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiUpdateSkillFaq', 'skillId', skillId)
            // verify required parameter 'upsertSkillFAQBody' is not null or undefined
            assertParamExists('skillApiUpdateSkillFaq', 'upsertSkillFAQBody', upsertSkillFAQBody)
            const localVarPath = `/admin/skill/{skill_id}/faq/{faq_id}`
                .replace('{faq_id}', encodeURIComponent(String(faqId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSkillFAQBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpdateSkillHiddenBody} updateSkillHiddenBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpdateSkillHidden: async (skillId: string, updateSkillHiddenBody: UpdateSkillHiddenBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiUpdateSkillHidden', 'skillId', skillId)
            // verify required parameter 'updateSkillHiddenBody' is not null or undefined
            assertParamExists('skillApiUpdateSkillHidden', 'updateSkillHiddenBody', updateSkillHiddenBody)
            const localVarPath = `/admin/skill/{skill_id}/hidden`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSkillHiddenBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} reviewId 
         * @param {string} skillId 
         * @param {UpdateSkillReviewBody} updateSkillReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpdateSkillReview: async (reviewId: string, skillId: string, updateSkillReviewBody: UpdateSkillReviewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewId' is not null or undefined
            assertParamExists('skillApiUpdateSkillReview', 'reviewId', reviewId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiUpdateSkillReview', 'skillId', skillId)
            // verify required parameter 'updateSkillReviewBody' is not null or undefined
            assertParamExists('skillApiUpdateSkillReview', 'updateSkillReviewBody', updateSkillReviewBody)
            const localVarPath = `/admin/skill/{skill_id}/review/{review_id}`
                .replace('{review_id}', encodeURIComponent(String(reviewId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSkillReviewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesId 
         * @param {UpsertSkillSeriesBody} upsertSkillSeriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpdateSkillSeries: async (seriesId: string, upsertSkillSeriesBody: UpsertSkillSeriesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesId' is not null or undefined
            assertParamExists('skillApiUpdateSkillSeries', 'seriesId', seriesId)
            // verify required parameter 'upsertSkillSeriesBody' is not null or undefined
            assertParamExists('skillApiUpdateSkillSeries', 'upsertSkillSeriesBody', upsertSkillSeriesBody)
            const localVarPath = `/admin/skill-series/{series_id}`
                .replace('{series_id}', encodeURIComponent(String(seriesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSkillSeriesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {File} [iconFile] 
         * @param {File} [headerImageFile] 
         * @param {File} [mobileHeaderFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUploadSkillImages: async (skillId: string, iconFile?: File, headerImageFile?: File, mobileHeaderFile?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiUploadSkillImages', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/upload-img`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (iconFile !== undefined) { 
                localVarFormParams.append('icon_file', iconFile as any);
            }

            if (headerImageFile !== undefined) { 
                localVarFormParams.append('header_image_file', headerImageFile as any);
            }

            if (mobileHeaderFile !== undefined) { 
                localVarFormParams.append('mobile_header_file', mobileHeaderFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpsertSkillContentBody} upsertSkillContentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpsertSkillContent: async (skillId: string, upsertSkillContentBody: UpsertSkillContentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('skillApiUpsertSkillContent', 'skillId', skillId)
            // verify required parameter 'upsertSkillContentBody' is not null or undefined
            assertParamExists('skillApiUpsertSkillContent', 'upsertSkillContentBody', upsertSkillContentBody)
            const localVarPath = `/admin/skill/{skill_id}/content`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSkillContentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SkillApiApi - functional programming interface
 */
export const SkillApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SkillApiApiAxiosParamCreator(configuration)
    return {
        /**
         * checked against its figure before it goes live; re-running tops up the gap.
         * @summary Add figure questions to a course\'s built lessons. Each is judged, drawn and
         * @param {string} moduleId 
         * @param {AddCourseImageQuestionsBody} addCourseImageQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAddCourseImageQuestions(moduleId: string, addCourseImageQuestionsBody: AddCourseImageQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCourseImageQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAddCourseImageQuestions(moduleId, addCourseImageQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAddCourseImageQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesId 
         * @param {AddSeriesCourseBody} addSeriesCourseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAddSeriesCourse(seriesId: string, addSeriesCourseBody: AddSeriesCourseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSeriesCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAddSeriesCourse(seriesId, addSeriesCourseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAddSeriesCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} rating 
         * @param {string} skillId 
         * @param {UserRatingParams} userRatingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAddSkillRating(rating: string, skillId: string, userRatingParams: UserRatingParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAddSkillRating(rating, skillId, userRatingParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAddSkillRating']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {AdminGenerateIntrosBody} adminGenerateIntrosBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAdminGenerateCourseIntros(moduleId: string, adminGenerateIntrosBody: AdminGenerateIntrosBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGenerateIntrosResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAdminGenerateCourseIntros(moduleId, adminGenerateIntrosBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAdminGenerateCourseIntros']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {AdminGenerateReadingMaterialBody} adminGenerateReadingMaterialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAdminGenerateMissingReadingMaterial(skillId: string, adminGenerateReadingMaterialBody: AdminGenerateReadingMaterialBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGenerateReadingMaterialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAdminGenerateMissingReadingMaterial(skillId, adminGenerateReadingMaterialBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAdminGenerateMissingReadingMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {AdminGenerateReadingMaterialBody} adminGenerateReadingMaterialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAdminGenerateReadingMaterial(skillId: string, adminGenerateReadingMaterialBody: AdminGenerateReadingMaterialBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGenerateReadingMaterialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAdminGenerateReadingMaterial(skillId, adminGenerateReadingMaterialBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAdminGenerateReadingMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAdminGetCourseIntros(moduleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminIntroStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAdminGetCourseIntros(moduleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAdminGetCourseIntros']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAdminGetReadingMaterialCostEstimate(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminReadingMaterialCostEstimateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAdminGetReadingMaterialCostEstimate(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAdminGetReadingMaterialCostEstimate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAdminGetReadingMaterialStatus(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminReadingMaterialStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAdminGetReadingMaterialStatus(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAdminGetReadingMaterialStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {AdminNarrateBody} adminNarrateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAdminNarrateCourse(skillId: string, adminNarrateBody: AdminNarrateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNarrateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAdminNarrateCourse(skillId, adminNarrateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAdminNarrateCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {AdminNarrateBody} adminNarrateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAdminNarrateLabel(skillId: string, adminNarrateBody: AdminNarrateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNarrateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAdminNarrateLabel(skillId, adminNarrateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAdminNarrateLabel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAdminNarrationCoverage(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseNarrationCoverageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAdminNarrationCoverage(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAdminNarrationCoverage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {AdminGenerateReadingMaterialBody} adminGenerateReadingMaterialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAdminRegeneratePoorReadingMaterial(skillId: string, adminGenerateReadingMaterialBody: AdminGenerateReadingMaterialBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGenerateReadingMaterialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAdminRegeneratePoorReadingMaterial(skillId, adminGenerateReadingMaterialBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAdminRegeneratePoorReadingMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {AdminRegenerateReadingMaterialBody} adminRegenerateReadingMaterialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAdminRegenerateReadingMaterial(skillId: string, adminRegenerateReadingMaterialBody: AdminRegenerateReadingMaterialBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAdminRegenerateReadingMaterial(skillId, adminRegenerateReadingMaterialBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAdminRegenerateReadingMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} sessionId 
         * @param {AttemptQuestionBody} attemptQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAttemptGuidedQuestion(questionId: string, sessionId: string, attemptQuestionBody: AttemptQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidedAttemptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAttemptGuidedQuestion(questionId, sessionId, attemptQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAttemptGuidedQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} sessionId 
         * @param {AttemptQuestionBody} attemptQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiAttemptTopicTestQuestion(questionId: string, sessionId: string, attemptQuestionBody: AttemptQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TopicTestAttemptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiAttemptTopicTestQuestion(questionId, sessionId, attemptQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiAttemptTopicTestQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The same sweep the cron runs. Exposed because beat only fires in PROD, so this is the only way to exercise it anywhere else — and `dry_run` answers \"which live courses are hollow right now\" without spending anything.
         * @summary Build the opening lessons of any live course still missing them.
         * @param {OpeningBackfillBody} openingBackfillBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiBackfillLiveCourseOpenings(openingBackfillBody: OpeningBackfillBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpeningBackfillResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiBackfillLiveCourseOpenings(openingBackfillBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiBackfillLiveCourseOpenings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NameList} nameList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiBulkCreateDomainsRoute(nameList: NameList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiBulkCreateDomainsRoute(nameList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiBulkCreateDomainsRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IDNames} iDNames 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiBulkCreateModulesRoute(iDNames: IDNames, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiBulkCreateModulesRoute(iDNames, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiBulkCreateModulesRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateTopicsSubtopicsBody} createTopicsSubtopicsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiBulkCreateTopicSubtopicRoute(createTopicsSubtopicsBody: CreateTopicsSubtopicsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiBulkCreateTopicSubtopicRoute(createTopicsSubtopicsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiBulkCreateTopicSubtopicRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiCancelCourseBuildJob(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiCancelCourseBuildJob(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiCancelCourseBuildJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} promotionId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiCancelCoursePromotion(promotionId: string, skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoursePromotionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiCancelCoursePromotion(promotionId, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiCancelCoursePromotion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} alias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiCheckSkillAliasAvailability(alias: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillAliasAvailabilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiCheckSkillAliasAvailability(alias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiCheckSkillAliasAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiCloseTopicJump(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloseTopicJumpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiCloseTopicJump(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiCloseTopicJump']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiCloseTopicTestSession(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloseTopicTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiCloseTopicTestSession(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiCloseTopicTestSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} labelId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiCompleteGuidedLabel(labelId: string, skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteLabelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiCompleteGuidedLabel(labelId, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiCompleteGuidedLabel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nodeId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiCompleteIntro(nodeId: string, skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteIntroResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiCompleteIntro(nodeId, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiCompleteIntro']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiContinueCourseBuildJob(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContinueCourseBuildResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiContinueCourseBuildJob(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiContinueCourseBuildJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiContinueStalledCourseBuildJobs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContinueCourseBuildResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiContinueStalledCourseBuildJobs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiContinueStalledCourseBuildJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiCourseBuildReadiness(moduleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseBuildReadiness>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiCourseBuildReadiness(moduleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiCourseBuildReadiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {CreateCoursePromotionBody} createCoursePromotionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiCreateCoursePromotion(skillId: string, createCoursePromotionBody: CreateCoursePromotionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoursePromotionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiCreateCoursePromotion(skillId, createCoursePromotionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiCreateCoursePromotion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpsertSkillFAQBody} upsertSkillFAQBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiCreateSkillFaq(skillId: string, upsertSkillFAQBody: UpsertSkillFAQBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillFAQItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiCreateSkillFaq(skillId, upsertSkillFAQBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiCreateSkillFaq']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {CreateSkillReviewBody} createSkillReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiCreateSkillReview(skillId: string, createSkillReviewBody: CreateSkillReviewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillReviewItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiCreateSkillReview(skillId, createSkillReviewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiCreateSkillReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertSkillSeriesBody} upsertSkillSeriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiCreateSkillSeries(upsertSkillSeriesBody: UpsertSkillSeriesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillSeriesItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiCreateSkillSeries(upsertSkillSeriesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiCreateSkillSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} confirmName 
         * @param {string} skillId 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiDeleteCourse(confirmName: string, skillId: string, dryRun?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiDeleteCourse(confirmName, skillId, dryRun, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiDeleteCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiDeleteCourseReview(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiDeleteCourseReview(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiDeleteCourseReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} faqId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiDeleteSkillFaq(faqId: string, skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiDeleteSkillFaq(faqId, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiDeleteSkillFaq']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} reviewId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiDeleteSkillReview(reviewId: string, skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiDeleteSkillReview(reviewId, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiDeleteSkillReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiDeleteSkillSeries(seriesId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiDeleteSkillSeries(seriesId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiDeleteSkillSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {DismissCourseReviewBody} dismissCourseReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiDismissCourseReview(skillId: string, dismissCourseReviewBody: DismissCourseReviewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissCourseReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiDismissCourseReview(skillId, dismissCourseReviewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiDismissCourseReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiDismissProgressResetNotice(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissProgressResetNoticeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiDismissProgressResetNotice(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiDismissProgressResetNotice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiDownloadGuidedCourseCertificate(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiDownloadGuidedCourseCertificate(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiDownloadGuidedCourseCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {number | null} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiDownloadSkillQuestions(skillId: string, limit?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiDownloadSkillQuestions(skillId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiDownloadSkillQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiEnrollGuidedCourse(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidedCourseEnrollResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiEnrollGuidedCourse(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiEnrollGuidedCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * entry point the learner flow will call when it reaches an unbuilt label.
         * @summary Build a single label on demand. Admin-facing for now; this is the same
         * @param {string} labelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiEnsureLabelBuilt(labelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnsureLabelBuiltResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiEnsureLabelBuilt(labelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiEnsureLabelBuilt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {string | null} [contentModel] 
         * @param {number | null} [labelLimit] 
         * @param {string | null} [questionModel] 
         * @param {number | null} [questionsPerLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiEstimateCourseBuild(moduleId: string, contentModel?: string | null, labelLimit?: number | null, questionModel?: string | null, questionsPerLabel?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseBuildEstimate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiEstimateCourseBuild(moduleId, contentModel, labelLimit, questionModel, questionsPerLabel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiEstimateCourseBuild']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {GenerateCodingQuestionsBody} generateCodingQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGenerateCodingQuestions(skillId: string, generateCodingQuestionsBody: GenerateCodingQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateCodingQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGenerateCodingQuestions(skillId, generateCodingQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGenerateCodingQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGenerateGuidedCourseCertificate(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateGuidedCourseCertificateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGenerateGuidedCourseCertificate(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGenerateGuidedCourseCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGenerateImageDensitySample(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateImageDensitySampleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGenerateImageDensitySample(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGenerateImageDensitySample']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {GenerateImageOnlyQuestionsBody} generateImageOnlyQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGenerateImageOnlyQuestions(skillId: string, generateImageOnlyQuestionsBody: GenerateImageOnlyQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateImageOnlyQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGenerateImageOnlyQuestions(skillId, generateImageOnlyQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGenerateImageOnlyQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [maxDate] 
         * @param {string} [minDate] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {string | null} [skillId] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortOrder] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetAdminSkillAnalytics(maxDate?: string, minDate?: string, pageNo?: number, pageSize?: number, searchQuery?: string, skillId?: string | null, sortBy?: string | null, sortOrder?: string | null, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetAdminSkillAnalytics(maxDate, minDate, pageNo, pageSize, searchQuery, skillId, sortBy, sortOrder, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetAdminSkillAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillType 
         * @param {boolean | null} [hasUnmapped] 
         * @param {boolean | null} [isCurrentlyGenerating] 
         * @param {boolean | null} [isGuidedCourse] 
         * @param {boolean | null} [isPublicListed] 
         * @param {boolean | null} [isSkillTreeAvailable] 
         * @param {number | null} [maxMappedCount] 
         * @param {number | null} [maxQuestionCount] 
         * @param {number | null} [minMappedCount] 
         * @param {number | null} [minQuestionCount] 
         * @param {boolean | null} [missingIcon] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [parentSkillId] 
         * @param {string} [searchText] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortOrder] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetAdminSkillListBySkillType(skillType: string, hasUnmapped?: boolean | null, isCurrentlyGenerating?: boolean | null, isGuidedCourse?: boolean | null, isPublicListed?: boolean | null, isSkillTreeAvailable?: boolean | null, maxMappedCount?: number | null, maxQuestionCount?: number | null, minMappedCount?: number | null, minQuestionCount?: number | null, missingIcon?: boolean | null, pageNo?: number, pageSize?: number, parentSkillId?: string | null, searchText?: string, sortBy?: string | null, sortOrder?: string | null, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillsListBySkillTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetAdminSkillListBySkillType(skillType, hasUnmapped, isCurrentlyGenerating, isGuidedCourse, isPublicListed, isSkillTreeAvailable, maxMappedCount, maxQuestionCount, minMappedCount, minQuestionCount, missingIcon, pageNo, pageSize, parentSkillId, searchText, sortBy, sortOrder, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetAdminSkillListBySkillType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetCoreSkillDetail(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSkillDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetCoreSkillDetail(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetCoreSkillDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetCoreSkillDuplicates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSkillDuplicatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetCoreSkillDuplicates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetCoreSkillDuplicates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SkillApiGetCoreSkillGapsViewEnum} [view] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetCoreSkillGaps(view?: SkillApiGetCoreSkillGapsViewEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreSkillGapsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetCoreSkillGaps(view, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetCoreSkillGaps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * dict — Flask\'s JSON provider sorts object keys and would scramble it).
         * @summary The module\'s saved hierarchy in true teaching order (ordered list, not a
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetCourseBuildHierarchy(moduleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseBuildHierarchyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetCourseBuildHierarchy(moduleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetCourseBuildHierarchy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetCourseBuildJob(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseBuildJobDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetCourseBuildJob(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetCourseBuildJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetCourseImageQuestions(moduleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseImageQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetCourseImageQuestions(moduleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetCourseImageQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetCoursePromotion(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCoursePromotionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetCoursePromotion(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetCoursePromotion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetGuidedCourseCertificate(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidedCourseCertificateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetGuidedCourseCertificate(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetGuidedCourseCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetGuidedCourseInfo(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidedCourseInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetGuidedCourseInfo(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetGuidedCourseInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetGuidedCourseMap(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidedCourseMapResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetGuidedCourseMap(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetGuidedCourseMap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetGuidedCourseProgress(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidedCourseProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetGuidedCourseProgress(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetGuidedCourseProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetGuidedCourseRelevance(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGuidedCourseRelevanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetGuidedCourseRelevance(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetGuidedCourseRelevance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [forceRefresh] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetGuidedCourses(forceRefresh?: boolean, limit?: number | null, offset?: number | null, q?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGuidedCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetGuidedCourses(forceRefresh, limit, offset, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetGuidedCourses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetGuidedCoursesProgress(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidedCoursesProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetGuidedCoursesProgress(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetGuidedCoursesProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetGuidedCurrentQuestion(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnansweredQuestionResponseSchemaSkillDict>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetGuidedCurrentQuestion(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetGuidedCurrentQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetGuidedSessionProgress(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidedSessionProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetGuidedSessionProgress(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetGuidedSessionProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nodeId 
         * @param {string} skillId 
         * @param {boolean} [forceWelcome] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetIntroContent(nodeId: string, skillId: string, forceWelcome?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIntroContentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetIntroContent(nodeId, skillId, forceWelcome, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetIntroContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Polled by the lesson loader. Also starts the build when nothing is running, so a lesson whose build died recovers without the learner doing anything — except right after one gave up, which needs `force` (the retry button).
         * @summary Progress of the lesson the learner is waiting on.
         * @param {string} labelId 
         * @param {string} skillId 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetLabelBuildStatus(labelId: string, skillId: string, force?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonBuildStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetLabelBuildStatus(labelId, skillId, force, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetLabelBuildStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} labelId 
         * @param {string} skillId 
         * @param {boolean} [supportsBuilding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetLabelContent(labelId: string, skillId: string, supportsBuilding?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLabelContentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetLabelContent(labelId, skillId, supportsBuilding, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetLabelContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetModulePublishStatus(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetModulePublishStatus(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetModulePublishStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetPublicSeriesList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPublicSeriesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetPublicSeriesList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetPublicSeriesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} aliasOrId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetPublicSkillDetail(aliasOrId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPublicSkillDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetPublicSkillDetail(aliasOrId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetPublicSkillDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string> | null} [categories] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetPublicSkillsHub(categories?: Array<string> | null, limit?: number | null, offset?: number | null, q?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPublicSkillsHubResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetPublicSkillsHub(categories, limit, offset, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetPublicSkillsHub']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetPublicSkillsList(pageNo?: number, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPublicSkillsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetPublicSkillsList(pageNo, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetPublicSkillsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetQuestionCreationSkillList(page?: number, pageSize?: number, searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCreatorSkillsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetQuestionCreationSkillList(page, pageSize, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetQuestionCreationSkillList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetReadingMaterial(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadingMaterialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetReadingMaterial(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetReadingMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillBadges(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBadgesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillBadges(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillBadges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} category 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillBrowse(category: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillBrowseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillBrowse(category, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillBrowse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillBuilderCertificate(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderCertificateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillBuilderCertificate(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillBuilderCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillBuilderCertificateProgress(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderCertificateProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillBuilderCertificateProgress(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillBuilderCertificateProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillByIdV2(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillByIdV2(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillByIdV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillCategories(limit?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillCategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillCategories(limit, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillContent(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillContentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillContent(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillCostEstimate(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillCostEstimateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillCostEstimate(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillCostEstimate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillDashboardSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillDashboardSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillDashboardSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillDashboardSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary This skill\'s AI-generation guidance plus what it inherits from ancestors.
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillGenerationPrompt(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillGenerationPromptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillGenerationPrompt(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillGenerationPrompt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillList(page?: number, pageSize?: number, searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillsResponseMain>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillList(page, pageSize, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [coreOnly] 
         * @param {string} [searchQuery] 
         * @param {string} [searchType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillListV2(coreOnly?: boolean, searchQuery?: string, searchType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillsV2ResponseMain>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillListV2(coreOnly, searchQuery, searchType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillListV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [domain] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchText] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortOrder] 
         * @param {string | null} [step] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillModuleTodos(domain?: string | null, pageNo?: number, pageSize?: number, searchText?: string, sortBy?: string | null, sortOrder?: string | null, step?: string | null, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillModuleTodosResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillModuleTodos(domain, pageNo, pageSize, searchText, sortBy, sortOrder, step, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillModuleTodos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {string | null} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillPercentile(skillId: string, username?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillPercentileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillPercentile(skillId, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillPercentile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillPreference(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillPreferencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillPreference(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillPublishReadiness(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishReadinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillPublishReadiness(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillPublishReadiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillRelatedCourses(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillRelatedCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillRelatedCourses(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillRelatedCourses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {string | null} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillReport(skillId: string, username?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillReport(skillId, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillStartStatistics(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillsStartStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillStartStatistics(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillStartStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetSkillTree(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillNameHierarchyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetSkillTree(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetSkillTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {number | null} [cardIndex] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetTheoryAiChats(skillId: string, cardIndex?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTheoryAIChatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetTheoryAiChats(skillId, cardIndex, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetTheoryAiChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetTopicJumpResult(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TopicJumpResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetTopicJumpResult(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetTopicJumpResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {string | null} [questionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetTopicTestCurrentQuestion(sessionId: string, questionId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnansweredQuestionResponseSchemaSkillDict>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetTopicTestCurrentQuestion(sessionId, questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetTopicTestCurrentQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetTopicTestProgress(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TopicTestProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetTopicTestProgress(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetTopicTestProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetTopicTestResult(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TopicTestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetTopicTestResult(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetTopicTestResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiGetUserSkillDetails(skillId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiGetUserSkillDetails(skillId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiGetUserSkillDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {SkillApiListAdminCourseFeedbackScopeEnum} [scope] 
         * @param {Array<string>} [skillIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiListAdminCourseFeedback(page?: number, pageSize?: number, scope?: SkillApiListAdminCourseFeedbackScopeEnum, skillIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCourseFeedbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiListAdminCourseFeedback(page, pageSize, scope, skillIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiListAdminCourseFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [pricing] 
         * @param {string | null} [q] 
         * @param {SkillApiListAdminCoursesRefreshedEnum} [refreshed] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiListAdminCourses(page?: number, pageSize?: number, pricing?: string, q?: string | null, refreshed?: SkillApiListAdminCoursesRefreshedEnum, sortBy?: string, sortOrder?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCoursesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiListAdminCourses(page, pageSize, pricing, q, refreshed, sortBy, sortOrder, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiListAdminCourses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [moduleId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiListCourseBuildJobs(moduleId?: string | null, page?: number, pageSize?: number, status?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseBuildJobListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiListCourseBuildJobs(moduleId, page, pageSize, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiListCourseBuildJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiListCoursePromotions(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCoursePromotionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiListCoursePromotions(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiListCoursePromotions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiListSeriesCourses(seriesId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSeriesCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiListSeriesCourses(seriesId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiListSeriesCourses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiListSkillFaqs(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillFAQListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiListSkillFaqs(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiListSkillFaqs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {boolean | null} [isFeatured] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [source] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiListSkillReviews(skillId: string, isFeatured?: boolean | null, pageNo?: number, pageSize?: number, source?: string | null, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillReviewListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiListSkillReviews(skillId, isFeatured, pageNo, pageSize, source, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiListSkillReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean | null} [isPublicListed] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiListSkillSeries(isPublicListed?: boolean | null, pageNo?: number, pageSize?: number, searchQuery?: string | null, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillSeriesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiListSkillSeries(isPublicListed, pageNo, pageSize, searchQuery, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiListSkillSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [dryRun] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiMergeDuplicatesByName(dryRun?: boolean, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiMergeDuplicatesByName(dryRun, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiMergeDuplicatesByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {PreviewCoursePromotionBody} previewCoursePromotionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiPreviewCoursePromotion(skillId: string, previewCoursePromotionBody: PreviewCoursePromotionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewCoursePromotionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiPreviewCoursePromotion(skillId, previewCoursePromotionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiPreviewCoursePromotion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PruneOrphanSkillsBody} pruneOrphanSkillsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiPruneOrphanSkills(pruneOrphanSkillsBody: PruneOrphanSkillsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PruneOrphanSkillsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiPruneOrphanSkills(pruneOrphanSkillsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiPruneOrphanSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {PublishModuleBody} publishModuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiPublishModule(skillId: string, publishModuleBody: PublishModuleBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishModuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiPublishModule(skillId, publishModuleBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiPublishModule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiPurchaseGuidedCourse(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiPurchaseGuidedCourse(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiPurchaseGuidedCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set the label\'s generation-prompt first — a rebuild with no guidance regenerates the same lesson from the same inputs.
         * @summary Replace a lesson: retire its questions, rewrite its cards, rebuild both.
         * @param {string} labelId 
         * @param {RebuildLabelBody} rebuildLabelBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiRebuildLabel(labelId: string, rebuildLabelBody: RebuildLabelBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RebuildLabelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiRebuildLabel(labelId, rebuildLabelBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiRebuildLabel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiRecomputeCoreSkills(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiRecomputeCoreSkills(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiRecomputeCoreSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiRecomputeSkillImageDensity(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecomputeSkillImageDensityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiRecomputeSkillImageDensity(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiRecomputeSkillImageDensity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiRecomputeSkillQuality(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecomputeSkillQualityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiRecomputeSkillQuality(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiRecomputeSkillQuality']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiRefillHearts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSkillBuilderMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiRefillHearts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiRefillHearts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiRemoveSeriesCourse(seriesId: string, skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSeriesCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiRemoveSeriesCourse(seriesId, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiRemoveSeriesCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiRenameSkill(name: string, skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiRenameSkill(name, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiRenameSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesId 
         * @param {ReorderSeriesBody} reorderSeriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiReorderSeriesCourses(seriesId: string, reorderSeriesBody: ReorderSeriesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSeriesCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiReorderSeriesCourses(seriesId, reorderSeriesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiReorderSeriesCourses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiResetSkillPublicContent(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiResetSkillPublicContent(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiResetSkillPublicContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {ResolveCoreSkillReviewBody} resolveCoreSkillReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiResolveCoreSkillReview(skillId: string, resolveCoreSkillReviewBody: ResolveCoreSkillReviewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetCoreSkillExclusionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiResolveCoreSkillReview(skillId, resolveCoreSkillReviewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiResolveCoreSkillReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} labelTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiRetryCourseBuildLabel(labelTaskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiRetryCourseBuildLabel(labelTaskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiRetryCourseBuildLabel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReviewCoreSkillsBody} reviewCoreSkillsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiReviewCoreSkills(reviewCoreSkillsBody: ReviewCoreSkillsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewCoreSkillsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiReviewCoreSkills(reviewCoreSkillsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiReviewCoreSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The from-scratch wizard uses this so the admin can see the improved order (and why it is better) before committing — nothing is persisted here.
         * @summary Pedagogical order review for a hierarchy that has not been saved yet.
         * @param {ReviewHierarchyOrderBody} reviewHierarchyOrderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiReviewHierarchyOrder(reviewHierarchyOrderBody: ReviewHierarchyOrderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiReviewHierarchyOrder(reviewHierarchyOrderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiReviewHierarchyOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiSaveMyStreak(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StreakResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiSaveMyStreak(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiSaveMyStreak']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {CoursePromotionTestEmailBody} coursePromotionTestEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiSendCoursePromotionTestEmail(skillId: string, coursePromotionTestEmailBody: CoursePromotionTestEmailBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoursePromotionTestEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiSendCoursePromotionTestEmail(skillId, coursePromotionTestEmailBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiSendCoursePromotionTestEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {SetCoreSkillExclusionBody} setCoreSkillExclusionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiSetCoreSkillExclusion(skillId: string, setCoreSkillExclusionBody: SetCoreSkillExclusionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetCoreSkillExclusionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiSetCoreSkillExclusion(skillId, setCoreSkillExclusionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiSetCoreSkillExclusion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {SetCourseIntroVisibilityBody} setCourseIntroVisibilityBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiSetCourseIntroVisibility(skillId: string, setCourseIntroVisibilityBody: SetCourseIntroVisibilityBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetCourseIntroVisibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiSetCourseIntroVisibility(skillId, setCourseIntroVisibilityBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiSetCourseIntroVisibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {SetCoursePricingBody} setCoursePricingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiSetCoursePricing(skillId: string, setCoursePricingBody: SetCoursePricingBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetCoursePricingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiSetCoursePricing(skillId, setCoursePricingBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiSetCoursePricing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Takes effect the next time that part of the tree is generated — writing it regenerates nothing on its own.
         * @summary Set or clear generation guidance on any level (Module/Topic/SubTopic/Label).
         * @param {string} skillId 
         * @param {SetSkillGenerationPromptBody} setSkillGenerationPromptBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiSetSkillGenerationPrompt(skillId: string, setSkillGenerationPromptBody: SetSkillGenerationPromptBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillGenerationPromptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiSetSkillGenerationPrompt(skillId, setSkillGenerationPromptBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiSetSkillGenerationPrompt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {IDList} iDList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiSetSkillPreference(skillId: string, iDList: IDList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiSetSkillPreference(skillId, iDList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiSetSkillPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {PublicListingBody} publicListingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiSetSkillPublicListing(skillId: string, publicListingBody: PublicListingBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillContentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiSetSkillPublicListing(skillId, publicListingBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiSetSkillPublicListing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiSkillAiAssistantUnlock(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIAssistantUnlockResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiSkillAiAssistantUnlock(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiSkillAiAssistantUnlock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {StartCourseBuildBody} startCourseBuildBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiStartCourseBuild(moduleId: string, startCourseBuildBody: StartCourseBuildBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseBuildJobStarted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiStartCourseBuild(moduleId, startCourseBuildBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiStartCourseBuild']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} labelId 
         * @param {string} skillId 
         * @param {StartGuidedLabelSessionBody} startGuidedLabelSessionBody 
         * @param {boolean} [supportsBuilding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiStartGuidedLabelSession(labelId: string, skillId: string, startGuidedLabelSessionBody: StartGuidedLabelSessionBody, supportsBuilding?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartGuidedLabelSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiStartGuidedLabelSession(labelId, skillId, startGuidedLabelSessionBody, supportsBuilding, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiStartGuidedLabelSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {string} topicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiStartGuidedTopicSession(skillId: string, topicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartGuidedTopicSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiStartGuidedTopicSession(skillId, topicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiStartGuidedTopicSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {string} topicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiStartTopicJump(skillId: string, topicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartGuidedTopicSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiStartTopicJump(skillId, topicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiStartTopicJump']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {SubmitCourseFeedbackBody} submitCourseFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiSubmitCourseFeedback(skillId: string, submitCourseFeedbackBody: SubmitCourseFeedbackBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitCourseFeedbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiSubmitCourseFeedback(skillId, submitCourseFeedbackBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiSubmitCourseFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {SubmitCourseReviewBody} submitCourseReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiSubmitCourseReview(skillId: string, submitCourseReviewBody: SubmitCourseReviewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitCourseReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiSubmitCourseReview(skillId, submitCourseReviewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiSubmitCourseReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {TheoryAIChatBody} theoryAIChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiTheoryAiChat(skillId: string, theoryAIChatBody: TheoryAIChatBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TheoryAIChatResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiTheoryAiChat(skillId, theoryAIChatBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiTheoryAiChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {ToggleGuidedCourseBody} toggleGuidedCourseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiToggleGuidedCourse(skillId: string, toggleGuidedCourseBody: ToggleGuidedCourseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToggleGuidedCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiToggleGuidedCourse(skillId, toggleGuidedCourseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiToggleGuidedCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpdateAllowImagesBody} updateAllowImagesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiUpdateSkillAllowImages(skillId: string, updateAllowImagesBody: UpdateAllowImagesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAllowImagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiUpdateSkillAllowImages(skillId, updateAllowImagesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiUpdateSkillAllowImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpdateSkillCategoriesBody} updateSkillCategoriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiUpdateSkillCategories(skillId: string, updateSkillCategoriesBody: UpdateSkillCategoriesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiUpdateSkillCategories(skillId, updateSkillCategoriesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiUpdateSkillCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} faqId 
         * @param {string} skillId 
         * @param {UpsertSkillFAQBody} upsertSkillFAQBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiUpdateSkillFaq(faqId: string, skillId: string, upsertSkillFAQBody: UpsertSkillFAQBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillFAQItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiUpdateSkillFaq(faqId, skillId, upsertSkillFAQBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiUpdateSkillFaq']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpdateSkillHiddenBody} updateSkillHiddenBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiUpdateSkillHidden(skillId: string, updateSkillHiddenBody: UpdateSkillHiddenBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSkillHiddenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiUpdateSkillHidden(skillId, updateSkillHiddenBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiUpdateSkillHidden']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} reviewId 
         * @param {string} skillId 
         * @param {UpdateSkillReviewBody} updateSkillReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiUpdateSkillReview(reviewId: string, skillId: string, updateSkillReviewBody: UpdateSkillReviewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillReviewItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiUpdateSkillReview(reviewId, skillId, updateSkillReviewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiUpdateSkillReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesId 
         * @param {UpsertSkillSeriesBody} upsertSkillSeriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiUpdateSkillSeries(seriesId: string, upsertSkillSeriesBody: UpsertSkillSeriesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillSeriesItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiUpdateSkillSeries(seriesId, upsertSkillSeriesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiUpdateSkillSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {File} [iconFile] 
         * @param {File} [headerImageFile] 
         * @param {File} [mobileHeaderFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiUploadSkillImages(skillId: string, iconFile?: File, headerImageFile?: File, mobileHeaderFile?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillImageUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiUploadSkillImages(skillId, iconFile, headerImageFile, mobileHeaderFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiUploadSkillImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpsertSkillContentBody} upsertSkillContentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skillApiUpsertSkillContent(skillId: string, upsertSkillContentBody: UpsertSkillContentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillContentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skillApiUpsertSkillContent(skillId, upsertSkillContentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApiApi.skillApiUpsertSkillContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SkillApiApi - factory interface
 */
export const SkillApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SkillApiApiFp(configuration)
    return {
        /**
         * checked against its figure before it goes live; re-running tops up the gap.
         * @summary Add figure questions to a course\'s built lessons. Each is judged, drawn and
         * @param {SkillApiApiSkillApiAddCourseImageQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAddCourseImageQuestions(requestParameters: SkillApiApiSkillApiAddCourseImageQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddCourseImageQuestionsResponse> {
            return localVarFp.skillApiAddCourseImageQuestions(requestParameters.moduleId, requestParameters.addCourseImageQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAddSeriesCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAddSeriesCourse(requestParameters: SkillApiApiSkillApiAddSeriesCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSeriesCoursesResponse> {
            return localVarFp.skillApiAddSeriesCourse(requestParameters.seriesId, requestParameters.addSeriesCourseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAddSkillRatingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAddSkillRating(requestParameters: SkillApiApiSkillApiAddSkillRatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiAddSkillRating(requestParameters.rating, requestParameters.skillId, requestParameters.userRatingParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAdminGenerateCourseIntrosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminGenerateCourseIntros(requestParameters: SkillApiApiSkillApiAdminGenerateCourseIntrosRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGenerateIntrosResponse> {
            return localVarFp.skillApiAdminGenerateCourseIntros(requestParameters.moduleId, requestParameters.adminGenerateIntrosBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAdminGenerateMissingReadingMaterialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminGenerateMissingReadingMaterial(requestParameters: SkillApiApiSkillApiAdminGenerateMissingReadingMaterialRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGenerateReadingMaterialResponse> {
            return localVarFp.skillApiAdminGenerateMissingReadingMaterial(requestParameters.skillId, requestParameters.adminGenerateReadingMaterialBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAdminGenerateReadingMaterialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminGenerateReadingMaterial(requestParameters: SkillApiApiSkillApiAdminGenerateReadingMaterialRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGenerateReadingMaterialResponse> {
            return localVarFp.skillApiAdminGenerateReadingMaterial(requestParameters.skillId, requestParameters.adminGenerateReadingMaterialBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAdminGetCourseIntrosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminGetCourseIntros(requestParameters: SkillApiApiSkillApiAdminGetCourseIntrosRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminIntroStatusResponse> {
            return localVarFp.skillApiAdminGetCourseIntros(requestParameters.moduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAdminGetReadingMaterialCostEstimateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminGetReadingMaterialCostEstimate(requestParameters: SkillApiApiSkillApiAdminGetReadingMaterialCostEstimateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminReadingMaterialCostEstimateResponse> {
            return localVarFp.skillApiAdminGetReadingMaterialCostEstimate(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAdminGetReadingMaterialStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminGetReadingMaterialStatus(requestParameters: SkillApiApiSkillApiAdminGetReadingMaterialStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminReadingMaterialStatusResponse> {
            return localVarFp.skillApiAdminGetReadingMaterialStatus(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAdminNarrateCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminNarrateCourse(requestParameters: SkillApiApiSkillApiAdminNarrateCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNarrateResponse> {
            return localVarFp.skillApiAdminNarrateCourse(requestParameters.skillId, requestParameters.adminNarrateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAdminNarrateLabelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminNarrateLabel(requestParameters: SkillApiApiSkillApiAdminNarrateLabelRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNarrateResponse> {
            return localVarFp.skillApiAdminNarrateLabel(requestParameters.skillId, requestParameters.adminNarrateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAdminNarrationCoverageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminNarrationCoverage(requestParameters: SkillApiApiSkillApiAdminNarrationCoverageRequest, options?: RawAxiosRequestConfig): AxiosPromise<CourseNarrationCoverageResponse> {
            return localVarFp.skillApiAdminNarrationCoverage(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAdminRegeneratePoorReadingMaterialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminRegeneratePoorReadingMaterial(requestParameters: SkillApiApiSkillApiAdminRegeneratePoorReadingMaterialRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGenerateReadingMaterialResponse> {
            return localVarFp.skillApiAdminRegeneratePoorReadingMaterial(requestParameters.skillId, requestParameters.adminGenerateReadingMaterialBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAdminRegenerateReadingMaterialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAdminRegenerateReadingMaterial(requestParameters: SkillApiApiSkillApiAdminRegenerateReadingMaterialRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiAdminRegenerateReadingMaterial(requestParameters.skillId, requestParameters.adminRegenerateReadingMaterialBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAttemptGuidedQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAttemptGuidedQuestion(requestParameters: SkillApiApiSkillApiAttemptGuidedQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidedAttemptResponse> {
            return localVarFp.skillApiAttemptGuidedQuestion(requestParameters.questionId, requestParameters.sessionId, requestParameters.attemptQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiAttemptTopicTestQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiAttemptTopicTestQuestion(requestParameters: SkillApiApiSkillApiAttemptTopicTestQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<TopicTestAttemptResponse> {
            return localVarFp.skillApiAttemptTopicTestQuestion(requestParameters.questionId, requestParameters.sessionId, requestParameters.attemptQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * The same sweep the cron runs. Exposed because beat only fires in PROD, so this is the only way to exercise it anywhere else — and `dry_run` answers \"which live courses are hollow right now\" without spending anything.
         * @summary Build the opening lessons of any live course still missing them.
         * @param {SkillApiApiSkillApiBackfillLiveCourseOpeningsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiBackfillLiveCourseOpenings(requestParameters: SkillApiApiSkillApiBackfillLiveCourseOpeningsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpeningBackfillResponse> {
            return localVarFp.skillApiBackfillLiveCourseOpenings(requestParameters.openingBackfillBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiBulkCreateDomainsRouteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiBulkCreateDomainsRoute(requestParameters: SkillApiApiSkillApiBulkCreateDomainsRouteRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiBulkCreateDomainsRoute(requestParameters.nameList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiBulkCreateModulesRouteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiBulkCreateModulesRoute(requestParameters: SkillApiApiSkillApiBulkCreateModulesRouteRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiBulkCreateModulesRoute(requestParameters.iDNames, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiBulkCreateTopicSubtopicRouteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiBulkCreateTopicSubtopicRoute(requestParameters: SkillApiApiSkillApiBulkCreateTopicSubtopicRouteRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiBulkCreateTopicSubtopicRoute(requestParameters.createTopicsSubtopicsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiCancelCourseBuildJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCancelCourseBuildJob(requestParameters: SkillApiApiSkillApiCancelCourseBuildJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiCancelCourseBuildJob(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiCancelCoursePromotionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCancelCoursePromotion(requestParameters: SkillApiApiSkillApiCancelCoursePromotionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoursePromotionResponse> {
            return localVarFp.skillApiCancelCoursePromotion(requestParameters.promotionId, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiCheckSkillAliasAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCheckSkillAliasAvailability(requestParameters: SkillApiApiSkillApiCheckSkillAliasAvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillAliasAvailabilityResponse> {
            return localVarFp.skillApiCheckSkillAliasAvailability(requestParameters.alias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiCloseTopicJumpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCloseTopicJump(requestParameters: SkillApiApiSkillApiCloseTopicJumpRequest, options?: RawAxiosRequestConfig): AxiosPromise<CloseTopicJumpResponse> {
            return localVarFp.skillApiCloseTopicJump(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiCloseTopicTestSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCloseTopicTestSession(requestParameters: SkillApiApiSkillApiCloseTopicTestSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CloseTopicTestResponse> {
            return localVarFp.skillApiCloseTopicTestSession(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiCompleteGuidedLabelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCompleteGuidedLabel(requestParameters: SkillApiApiSkillApiCompleteGuidedLabelRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompleteLabelResponse> {
            return localVarFp.skillApiCompleteGuidedLabel(requestParameters.labelId, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiCompleteIntroRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCompleteIntro(requestParameters: SkillApiApiSkillApiCompleteIntroRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompleteIntroResponse> {
            return localVarFp.skillApiCompleteIntro(requestParameters.nodeId, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiContinueCourseBuildJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiContinueCourseBuildJob(requestParameters: SkillApiApiSkillApiContinueCourseBuildJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContinueCourseBuildResponse> {
            return localVarFp.skillApiContinueCourseBuildJob(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiContinueStalledCourseBuildJobs(options?: RawAxiosRequestConfig): AxiosPromise<ContinueCourseBuildResponse> {
            return localVarFp.skillApiContinueStalledCourseBuildJobs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiCourseBuildReadinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCourseBuildReadiness(requestParameters: SkillApiApiSkillApiCourseBuildReadinessRequest, options?: RawAxiosRequestConfig): AxiosPromise<CourseBuildReadiness> {
            return localVarFp.skillApiCourseBuildReadiness(requestParameters.moduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiCreateCoursePromotionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCreateCoursePromotion(requestParameters: SkillApiApiSkillApiCreateCoursePromotionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoursePromotionResponse> {
            return localVarFp.skillApiCreateCoursePromotion(requestParameters.skillId, requestParameters.createCoursePromotionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiCreateSkillFaqRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCreateSkillFaq(requestParameters: SkillApiApiSkillApiCreateSkillFaqRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillFAQItem> {
            return localVarFp.skillApiCreateSkillFaq(requestParameters.skillId, requestParameters.upsertSkillFAQBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiCreateSkillReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCreateSkillReview(requestParameters: SkillApiApiSkillApiCreateSkillReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillReviewItem> {
            return localVarFp.skillApiCreateSkillReview(requestParameters.skillId, requestParameters.createSkillReviewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiCreateSkillSeriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiCreateSkillSeries(requestParameters: SkillApiApiSkillApiCreateSkillSeriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillSeriesItem> {
            return localVarFp.skillApiCreateSkillSeries(requestParameters.upsertSkillSeriesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiDeleteCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDeleteCourse(requestParameters: SkillApiApiSkillApiDeleteCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteCourseResponse> {
            return localVarFp.skillApiDeleteCourse(requestParameters.confirmName, requestParameters.skillId, requestParameters.dryRun, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiDeleteCourseReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDeleteCourseReview(requestParameters: SkillApiApiSkillApiDeleteCourseReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiDeleteCourseReview(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiDeleteSkillFaqRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDeleteSkillFaq(requestParameters: SkillApiApiSkillApiDeleteSkillFaqRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiDeleteSkillFaq(requestParameters.faqId, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiDeleteSkillReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDeleteSkillReview(requestParameters: SkillApiApiSkillApiDeleteSkillReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiDeleteSkillReview(requestParameters.reviewId, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiDeleteSkillSeriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDeleteSkillSeries(requestParameters: SkillApiApiSkillApiDeleteSkillSeriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiDeleteSkillSeries(requestParameters.seriesId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiDismissCourseReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDismissCourseReview(requestParameters: SkillApiApiSkillApiDismissCourseReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissCourseReviewResponse> {
            return localVarFp.skillApiDismissCourseReview(requestParameters.skillId, requestParameters.dismissCourseReviewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiDismissProgressResetNoticeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDismissProgressResetNotice(requestParameters: SkillApiApiSkillApiDismissProgressResetNoticeRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissProgressResetNoticeResponse> {
            return localVarFp.skillApiDismissProgressResetNotice(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiDownloadGuidedCourseCertificateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDownloadGuidedCourseCertificate(requestParameters: SkillApiApiSkillApiDownloadGuidedCourseCertificateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.skillApiDownloadGuidedCourseCertificate(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiDownloadSkillQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiDownloadSkillQuestions(requestParameters: SkillApiApiSkillApiDownloadSkillQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.skillApiDownloadSkillQuestions(requestParameters.skillId, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiEnrollGuidedCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiEnrollGuidedCourse(requestParameters: SkillApiApiSkillApiEnrollGuidedCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidedCourseEnrollResponse> {
            return localVarFp.skillApiEnrollGuidedCourse(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * entry point the learner flow will call when it reaches an unbuilt label.
         * @summary Build a single label on demand. Admin-facing for now; this is the same
         * @param {SkillApiApiSkillApiEnsureLabelBuiltRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiEnsureLabelBuilt(requestParameters: SkillApiApiSkillApiEnsureLabelBuiltRequest, options?: RawAxiosRequestConfig): AxiosPromise<EnsureLabelBuiltResponse> {
            return localVarFp.skillApiEnsureLabelBuilt(requestParameters.labelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiEstimateCourseBuildRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiEstimateCourseBuild(requestParameters: SkillApiApiSkillApiEstimateCourseBuildRequest, options?: RawAxiosRequestConfig): AxiosPromise<CourseBuildEstimate> {
            return localVarFp.skillApiEstimateCourseBuild(requestParameters.moduleId, requestParameters.contentModel, requestParameters.labelLimit, requestParameters.questionModel, requestParameters.questionsPerLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGenerateCodingQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGenerateCodingQuestions(requestParameters: SkillApiApiSkillApiGenerateCodingQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateCodingQuestionsResponse> {
            return localVarFp.skillApiGenerateCodingQuestions(requestParameters.skillId, requestParameters.generateCodingQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGenerateGuidedCourseCertificateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGenerateGuidedCourseCertificate(requestParameters: SkillApiApiSkillApiGenerateGuidedCourseCertificateRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateGuidedCourseCertificateResponse> {
            return localVarFp.skillApiGenerateGuidedCourseCertificate(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGenerateImageDensitySampleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGenerateImageDensitySample(requestParameters: SkillApiApiSkillApiGenerateImageDensitySampleRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateImageDensitySampleResponse> {
            return localVarFp.skillApiGenerateImageDensitySample(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGenerateImageOnlyQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGenerateImageOnlyQuestions(requestParameters: SkillApiApiSkillApiGenerateImageOnlyQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateImageOnlyQuestionsResponse> {
            return localVarFp.skillApiGenerateImageOnlyQuestions(requestParameters.skillId, requestParameters.generateImageOnlyQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetAdminSkillAnalyticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetAdminSkillAnalytics(requestParameters: SkillApiApiSkillApiGetAdminSkillAnalyticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillStatsResponse> {
            return localVarFp.skillApiGetAdminSkillAnalytics(requestParameters.maxDate, requestParameters.minDate, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.skillId, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetAdminSkillListBySkillTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetAdminSkillListBySkillType(requestParameters: SkillApiApiSkillApiGetAdminSkillListBySkillTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillsListBySkillTypeResponse> {
            return localVarFp.skillApiGetAdminSkillListBySkillType(requestParameters.skillType, requestParameters.hasUnmapped, requestParameters.isCurrentlyGenerating, requestParameters.isGuidedCourse, requestParameters.isPublicListed, requestParameters.isSkillTreeAvailable, requestParameters.maxMappedCount, requestParameters.maxQuestionCount, requestParameters.minMappedCount, requestParameters.minQuestionCount, requestParameters.missingIcon, requestParameters.pageNo, requestParameters.pageSize, requestParameters.parentSkillId, requestParameters.searchText, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetCoreSkillDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCoreSkillDetail(requestParameters: SkillApiApiSkillApiGetCoreSkillDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoreSkillDetailResponse> {
            return localVarFp.skillApiGetCoreSkillDetail(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCoreSkillDuplicates(options?: RawAxiosRequestConfig): AxiosPromise<CoreSkillDuplicatesResponse> {
            return localVarFp.skillApiGetCoreSkillDuplicates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetCoreSkillGapsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCoreSkillGaps(requestParameters: SkillApiApiSkillApiGetCoreSkillGapsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CoreSkillGapsResponse> {
            return localVarFp.skillApiGetCoreSkillGaps(requestParameters.view, options).then((request) => request(axios, basePath));
        },
        /**
         * dict — Flask\'s JSON provider sorts object keys and would scramble it).
         * @summary The module\'s saved hierarchy in true teaching order (ordered list, not a
         * @param {SkillApiApiSkillApiGetCourseBuildHierarchyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCourseBuildHierarchy(requestParameters: SkillApiApiSkillApiGetCourseBuildHierarchyRequest, options?: RawAxiosRequestConfig): AxiosPromise<CourseBuildHierarchyResponse> {
            return localVarFp.skillApiGetCourseBuildHierarchy(requestParameters.moduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetCourseBuildJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCourseBuildJob(requestParameters: SkillApiApiSkillApiGetCourseBuildJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<CourseBuildJobDetail> {
            return localVarFp.skillApiGetCourseBuildJob(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetCourseImageQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCourseImageQuestions(requestParameters: SkillApiApiSkillApiGetCourseImageQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CourseImageQuestionsResponse> {
            return localVarFp.skillApiGetCourseImageQuestions(requestParameters.moduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetCoursePromotionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetCoursePromotion(requestParameters: SkillApiApiSkillApiGetCoursePromotionRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCoursePromotionResponse> {
            return localVarFp.skillApiGetCoursePromotion(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetGuidedCourseCertificateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCourseCertificate(requestParameters: SkillApiApiSkillApiGetGuidedCourseCertificateRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidedCourseCertificateResponse> {
            return localVarFp.skillApiGetGuidedCourseCertificate(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetGuidedCourseInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCourseInfo(requestParameters: SkillApiApiSkillApiGetGuidedCourseInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidedCourseInfoResponse> {
            return localVarFp.skillApiGetGuidedCourseInfo(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetGuidedCourseMapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCourseMap(requestParameters: SkillApiApiSkillApiGetGuidedCourseMapRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidedCourseMapResponse> {
            return localVarFp.skillApiGetGuidedCourseMap(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetGuidedCourseProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCourseProgress(requestParameters: SkillApiApiSkillApiGetGuidedCourseProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidedCourseProgressResponse> {
            return localVarFp.skillApiGetGuidedCourseProgress(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCourseRelevance(options?: RawAxiosRequestConfig): AxiosPromise<GetGuidedCourseRelevanceResponse> {
            return localVarFp.skillApiGetGuidedCourseRelevance(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetGuidedCoursesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCourses(requestParameters: SkillApiApiSkillApiGetGuidedCoursesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetGuidedCoursesResponse> {
            return localVarFp.skillApiGetGuidedCourses(requestParameters.forceRefresh, requestParameters.limit, requestParameters.offset, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCoursesProgress(options?: RawAxiosRequestConfig): AxiosPromise<GuidedCoursesProgressResponse> {
            return localVarFp.skillApiGetGuidedCoursesProgress(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetGuidedCurrentQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedCurrentQuestion(requestParameters: SkillApiApiSkillApiGetGuidedCurrentQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnansweredQuestionResponseSchemaSkillDict> {
            return localVarFp.skillApiGetGuidedCurrentQuestion(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetGuidedSessionProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetGuidedSessionProgress(requestParameters: SkillApiApiSkillApiGetGuidedSessionProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuidedSessionProgressResponse> {
            return localVarFp.skillApiGetGuidedSessionProgress(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetIntroContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetIntroContent(requestParameters: SkillApiApiSkillApiGetIntroContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetIntroContentResponse> {
            return localVarFp.skillApiGetIntroContent(requestParameters.nodeId, requestParameters.skillId, requestParameters.forceWelcome, options).then((request) => request(axios, basePath));
        },
        /**
         * Polled by the lesson loader. Also starts the build when nothing is running, so a lesson whose build died recovers without the learner doing anything — except right after one gave up, which needs `force` (the retry button).
         * @summary Progress of the lesson the learner is waiting on.
         * @param {SkillApiApiSkillApiGetLabelBuildStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetLabelBuildStatus(requestParameters: SkillApiApiSkillApiGetLabelBuildStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<LessonBuildStatusResponse> {
            return localVarFp.skillApiGetLabelBuildStatus(requestParameters.labelId, requestParameters.skillId, requestParameters.force, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetLabelContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetLabelContent(requestParameters: SkillApiApiSkillApiGetLabelContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetLabelContentResponse> {
            return localVarFp.skillApiGetLabelContent(requestParameters.labelId, requestParameters.skillId, requestParameters.supportsBuilding, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetModulePublishStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetModulePublishStatus(requestParameters: SkillApiApiSkillApiGetModulePublishStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublishStatusResponse> {
            return localVarFp.skillApiGetModulePublishStatus(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetPublicSeriesList(options?: RawAxiosRequestConfig): AxiosPromise<GetPublicSeriesListResponse> {
            return localVarFp.skillApiGetPublicSeriesList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetPublicSkillDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetPublicSkillDetail(requestParameters: SkillApiApiSkillApiGetPublicSkillDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPublicSkillDetailResponse> {
            return localVarFp.skillApiGetPublicSkillDetail(requestParameters.aliasOrId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetPublicSkillsHubRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetPublicSkillsHub(requestParameters: SkillApiApiSkillApiGetPublicSkillsHubRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetPublicSkillsHubResponse> {
            return localVarFp.skillApiGetPublicSkillsHub(requestParameters.categories, requestParameters.limit, requestParameters.offset, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetPublicSkillsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetPublicSkillsList(requestParameters: SkillApiApiSkillApiGetPublicSkillsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetPublicSkillsListResponse> {
            return localVarFp.skillApiGetPublicSkillsList(requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetQuestionCreationSkillListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetQuestionCreationSkillList(requestParameters: SkillApiApiSkillApiGetQuestionCreationSkillListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCreatorSkillsResponse>> {
            return localVarFp.skillApiGetQuestionCreationSkillList(requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetReadingMaterialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetReadingMaterial(requestParameters: SkillApiApiSkillApiGetReadingMaterialRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReadingMaterialResponse> {
            return localVarFp.skillApiGetReadingMaterial(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillBadgesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillBadges(requestParameters: SkillApiApiSkillApiGetSkillBadgesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBadgesResponse> {
            return localVarFp.skillApiGetSkillBadges(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillBrowseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillBrowse(requestParameters: SkillApiApiSkillApiGetSkillBrowseRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillBrowseResponse> {
            return localVarFp.skillApiGetSkillBrowse(requestParameters.category, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillBuilderCertificateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillBuilderCertificate(requestParameters: SkillApiApiSkillApiGetSkillBuilderCertificateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderCertificateResponse> {
            return localVarFp.skillApiGetSkillBuilderCertificate(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillBuilderCertificateProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillBuilderCertificateProgress(requestParameters: SkillApiApiSkillApiGetSkillBuilderCertificateProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderCertificateProgressResponse> {
            return localVarFp.skillApiGetSkillBuilderCertificateProgress(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillByIdV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillByIdV2(requestParameters: SkillApiApiSkillApiGetSkillByIdV2Request, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillsResponse> {
            return localVarFp.skillApiGetSkillByIdV2(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillCategories(requestParameters: SkillApiApiSkillApiGetSkillCategoriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillCategoriesResponse> {
            return localVarFp.skillApiGetSkillCategories(requestParameters.limit, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillContent(requestParameters: SkillApiApiSkillApiGetSkillContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillContentResponse> {
            return localVarFp.skillApiGetSkillContent(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillCostEstimateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillCostEstimate(requestParameters: SkillApiApiSkillApiGetSkillCostEstimateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillCostEstimateResponse> {
            return localVarFp.skillApiGetSkillCostEstimate(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillDashboardSummary(options?: RawAxiosRequestConfig): AxiosPromise<SkillDashboardSummaryResponse> {
            return localVarFp.skillApiGetSkillDashboardSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This skill\'s AI-generation guidance plus what it inherits from ancestors.
         * @param {SkillApiApiSkillApiGetSkillGenerationPromptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillGenerationPrompt(requestParameters: SkillApiApiSkillApiGetSkillGenerationPromptRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillGenerationPromptResponse> {
            return localVarFp.skillApiGetSkillGenerationPrompt(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillList(requestParameters: SkillApiApiSkillApiGetSkillListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillsResponseMain> {
            return localVarFp.skillApiGetSkillList(requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillListV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillListV2(requestParameters: SkillApiApiSkillApiGetSkillListV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillsV2ResponseMain> {
            return localVarFp.skillApiGetSkillListV2(requestParameters.coreOnly, requestParameters.searchQuery, requestParameters.searchType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillModuleTodosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillModuleTodos(requestParameters: SkillApiApiSkillApiGetSkillModuleTodosRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillModuleTodosResponse> {
            return localVarFp.skillApiGetSkillModuleTodos(requestParameters.domain, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchText, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.step, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillPercentileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillPercentile(requestParameters: SkillApiApiSkillApiGetSkillPercentileRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillPercentileResponse> {
            return localVarFp.skillApiGetSkillPercentile(requestParameters.skillId, requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillPreferenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillPreference(requestParameters: SkillApiApiSkillApiGetSkillPreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillPreferencesResponse> {
            return localVarFp.skillApiGetSkillPreference(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillPublishReadinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillPublishReadiness(requestParameters: SkillApiApiSkillApiGetSkillPublishReadinessRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublishReadinessResponse> {
            return localVarFp.skillApiGetSkillPublishReadiness(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillRelatedCoursesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillRelatedCourses(requestParameters: SkillApiApiSkillApiGetSkillRelatedCoursesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillRelatedCoursesResponse> {
            return localVarFp.skillApiGetSkillRelatedCourses(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillReport(requestParameters: SkillApiApiSkillApiGetSkillReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillReportResponse> {
            return localVarFp.skillApiGetSkillReport(requestParameters.skillId, requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillStartStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillStartStatistics(requestParameters: SkillApiApiSkillApiGetSkillStartStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillsStartStatisticsResponse> {
            return localVarFp.skillApiGetSkillStartStatistics(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetSkillTreeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetSkillTree(requestParameters: SkillApiApiSkillApiGetSkillTreeRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillNameHierarchyResponse> {
            return localVarFp.skillApiGetSkillTree(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetTheoryAiChatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetTheoryAiChats(requestParameters: SkillApiApiSkillApiGetTheoryAiChatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetTheoryAIChatsResponse> {
            return localVarFp.skillApiGetTheoryAiChats(requestParameters.skillId, requestParameters.cardIndex, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetTopicJumpResultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetTopicJumpResult(requestParameters: SkillApiApiSkillApiGetTopicJumpResultRequest, options?: RawAxiosRequestConfig): AxiosPromise<TopicJumpResult> {
            return localVarFp.skillApiGetTopicJumpResult(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetTopicTestCurrentQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetTopicTestCurrentQuestion(requestParameters: SkillApiApiSkillApiGetTopicTestCurrentQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnansweredQuestionResponseSchemaSkillDict> {
            return localVarFp.skillApiGetTopicTestCurrentQuestion(requestParameters.sessionId, requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetTopicTestProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetTopicTestProgress(requestParameters: SkillApiApiSkillApiGetTopicTestProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<TopicTestProgressResponse> {
            return localVarFp.skillApiGetTopicTestProgress(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetTopicTestResultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetTopicTestResult(requestParameters: SkillApiApiSkillApiGetTopicTestResultRequest, options?: RawAxiosRequestConfig): AxiosPromise<TopicTestResult> {
            return localVarFp.skillApiGetTopicTestResult(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiGetUserSkillDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiGetUserSkillDetails(requestParameters: SkillApiApiSkillApiGetUserSkillDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillsResponse> {
            return localVarFp.skillApiGetUserSkillDetails(requestParameters.skillId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiListAdminCourseFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListAdminCourseFeedback(requestParameters: SkillApiApiSkillApiListAdminCourseFeedbackRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminCourseFeedbackResponse> {
            return localVarFp.skillApiListAdminCourseFeedback(requestParameters.page, requestParameters.pageSize, requestParameters.scope, requestParameters.skillIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiListAdminCoursesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListAdminCourses(requestParameters: SkillApiApiSkillApiListAdminCoursesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminCoursesListResponse> {
            return localVarFp.skillApiListAdminCourses(requestParameters.page, requestParameters.pageSize, requestParameters.pricing, requestParameters.q, requestParameters.refreshed, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiListCourseBuildJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListCourseBuildJobs(requestParameters: SkillApiApiSkillApiListCourseBuildJobsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CourseBuildJobListResponse> {
            return localVarFp.skillApiListCourseBuildJobs(requestParameters.moduleId, requestParameters.page, requestParameters.pageSize, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiListCoursePromotionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListCoursePromotions(requestParameters: SkillApiApiSkillApiListCoursePromotionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCoursePromotionListResponse> {
            return localVarFp.skillApiListCoursePromotions(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiListSeriesCoursesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListSeriesCourses(requestParameters: SkillApiApiSkillApiListSeriesCoursesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSeriesCoursesResponse> {
            return localVarFp.skillApiListSeriesCourses(requestParameters.seriesId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiListSkillFaqsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListSkillFaqs(requestParameters: SkillApiApiSkillApiListSkillFaqsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillFAQListResponse> {
            return localVarFp.skillApiListSkillFaqs(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiListSkillReviewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListSkillReviews(requestParameters: SkillApiApiSkillApiListSkillReviewsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillReviewListResponse> {
            return localVarFp.skillApiListSkillReviews(requestParameters.skillId, requestParameters.isFeatured, requestParameters.pageNo, requestParameters.pageSize, requestParameters.source, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiListSkillSeriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiListSkillSeries(requestParameters: SkillApiApiSkillApiListSkillSeriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillSeriesListResponse> {
            return localVarFp.skillApiListSkillSeries(requestParameters.isPublicListed, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiMergeDuplicatesByNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiMergeDuplicatesByName(requestParameters: SkillApiApiSkillApiMergeDuplicatesByNameRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ResponseResult> {
            return localVarFp.skillApiMergeDuplicatesByName(requestParameters.dryRun, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiPreviewCoursePromotionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiPreviewCoursePromotion(requestParameters: SkillApiApiSkillApiPreviewCoursePromotionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreviewCoursePromotionResponse> {
            return localVarFp.skillApiPreviewCoursePromotion(requestParameters.skillId, requestParameters.previewCoursePromotionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiPruneOrphanSkillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiPruneOrphanSkills(requestParameters: SkillApiApiSkillApiPruneOrphanSkillsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PruneOrphanSkillsResponse> {
            return localVarFp.skillApiPruneOrphanSkills(requestParameters.pruneOrphanSkillsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiPublishModuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiPublishModule(requestParameters: SkillApiApiSkillApiPublishModuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublishModuleResponse> {
            return localVarFp.skillApiPublishModule(requestParameters.skillId, requestParameters.publishModuleBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiPurchaseGuidedCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiPurchaseGuidedCourse(requestParameters: SkillApiApiSkillApiPurchaseGuidedCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<PurchaseCourseResponse> {
            return localVarFp.skillApiPurchaseGuidedCourse(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the label\'s generation-prompt first — a rebuild with no guidance regenerates the same lesson from the same inputs.
         * @summary Replace a lesson: retire its questions, rewrite its cards, rebuild both.
         * @param {SkillApiApiSkillApiRebuildLabelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRebuildLabel(requestParameters: SkillApiApiSkillApiRebuildLabelRequest, options?: RawAxiosRequestConfig): AxiosPromise<RebuildLabelResponse> {
            return localVarFp.skillApiRebuildLabel(requestParameters.labelId, requestParameters.rebuildLabelBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRecomputeCoreSkills(options?: RawAxiosRequestConfig): AxiosPromise<ResponseResult> {
            return localVarFp.skillApiRecomputeCoreSkills(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiRecomputeSkillImageDensityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRecomputeSkillImageDensity(requestParameters: SkillApiApiSkillApiRecomputeSkillImageDensityRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecomputeSkillImageDensityResponse> {
            return localVarFp.skillApiRecomputeSkillImageDensity(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiRecomputeSkillQualityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRecomputeSkillQuality(requestParameters: SkillApiApiSkillApiRecomputeSkillQualityRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecomputeSkillQualityResponse> {
            return localVarFp.skillApiRecomputeSkillQuality(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRefillHearts(options?: RawAxiosRequestConfig): AxiosPromise<UserSkillBuilderMetadata> {
            return localVarFp.skillApiRefillHearts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiRemoveSeriesCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRemoveSeriesCourse(requestParameters: SkillApiApiSkillApiRemoveSeriesCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSeriesCoursesResponse> {
            return localVarFp.skillApiRemoveSeriesCourse(requestParameters.seriesId, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiRenameSkillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRenameSkill(requestParameters: SkillApiApiSkillApiRenameSkillRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiRenameSkill(requestParameters.name, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiReorderSeriesCoursesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiReorderSeriesCourses(requestParameters: SkillApiApiSkillApiReorderSeriesCoursesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSeriesCoursesResponse> {
            return localVarFp.skillApiReorderSeriesCourses(requestParameters.seriesId, requestParameters.reorderSeriesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiResetSkillPublicContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiResetSkillPublicContent(requestParameters: SkillApiApiSkillApiResetSkillPublicContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiResetSkillPublicContent(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiResolveCoreSkillReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiResolveCoreSkillReview(requestParameters: SkillApiApiSkillApiResolveCoreSkillReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<SetCoreSkillExclusionResponse> {
            return localVarFp.skillApiResolveCoreSkillReview(requestParameters.skillId, requestParameters.resolveCoreSkillReviewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiRetryCourseBuildLabelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiRetryCourseBuildLabel(requestParameters: SkillApiApiSkillApiRetryCourseBuildLabelRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiRetryCourseBuildLabel(requestParameters.labelTaskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiReviewCoreSkillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiReviewCoreSkills(requestParameters: SkillApiApiSkillApiReviewCoreSkillsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReviewCoreSkillsResponse> {
            return localVarFp.skillApiReviewCoreSkills(requestParameters.reviewCoreSkillsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * The from-scratch wizard uses this so the admin can see the improved order (and why it is better) before committing — nothing is persisted here.
         * @summary Pedagogical order review for a hierarchy that has not been saved yet.
         * @param {SkillApiApiSkillApiReviewHierarchyOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiReviewHierarchyOrder(requestParameters: SkillApiApiSkillApiReviewHierarchyOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiReviewHierarchyOrder(requestParameters.reviewHierarchyOrderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiSaveMyStreakRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSaveMyStreak(requestParameters: SkillApiApiSkillApiSaveMyStreakRequest, options?: RawAxiosRequestConfig): AxiosPromise<StreakResponse> {
            return localVarFp.skillApiSaveMyStreak(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiSendCoursePromotionTestEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSendCoursePromotionTestEmail(requestParameters: SkillApiApiSkillApiSendCoursePromotionTestEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoursePromotionTestEmailResponse> {
            return localVarFp.skillApiSendCoursePromotionTestEmail(requestParameters.skillId, requestParameters.coursePromotionTestEmailBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiSetCoreSkillExclusionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSetCoreSkillExclusion(requestParameters: SkillApiApiSkillApiSetCoreSkillExclusionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SetCoreSkillExclusionResponse> {
            return localVarFp.skillApiSetCoreSkillExclusion(requestParameters.skillId, requestParameters.setCoreSkillExclusionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiSetCourseIntroVisibilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSetCourseIntroVisibility(requestParameters: SkillApiApiSkillApiSetCourseIntroVisibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<SetCourseIntroVisibilityResponse> {
            return localVarFp.skillApiSetCourseIntroVisibility(requestParameters.skillId, requestParameters.setCourseIntroVisibilityBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiSetCoursePricingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSetCoursePricing(requestParameters: SkillApiApiSkillApiSetCoursePricingRequest, options?: RawAxiosRequestConfig): AxiosPromise<SetCoursePricingResponse> {
            return localVarFp.skillApiSetCoursePricing(requestParameters.skillId, requestParameters.setCoursePricingBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Takes effect the next time that part of the tree is generated — writing it regenerates nothing on its own.
         * @summary Set or clear generation guidance on any level (Module/Topic/SubTopic/Label).
         * @param {SkillApiApiSkillApiSetSkillGenerationPromptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSetSkillGenerationPrompt(requestParameters: SkillApiApiSkillApiSetSkillGenerationPromptRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillGenerationPromptResponse> {
            return localVarFp.skillApiSetSkillGenerationPrompt(requestParameters.skillId, requestParameters.setSkillGenerationPromptBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiSetSkillPreferenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSetSkillPreference(requestParameters: SkillApiApiSkillApiSetSkillPreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ErrorResponse> {
            return localVarFp.skillApiSetSkillPreference(requestParameters.skillId, requestParameters.iDList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiSetSkillPublicListingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSetSkillPublicListing(requestParameters: SkillApiApiSkillApiSetSkillPublicListingRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillContentResponse> {
            return localVarFp.skillApiSetSkillPublicListing(requestParameters.skillId, requestParameters.publicListingBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiSkillAiAssistantUnlockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSkillAiAssistantUnlock(requestParameters: SkillApiApiSkillApiSkillAiAssistantUnlockRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIAssistantUnlockResponse> {
            return localVarFp.skillApiSkillAiAssistantUnlock(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiStartCourseBuildRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiStartCourseBuild(requestParameters: SkillApiApiSkillApiStartCourseBuildRequest, options?: RawAxiosRequestConfig): AxiosPromise<CourseBuildJobStarted> {
            return localVarFp.skillApiStartCourseBuild(requestParameters.moduleId, requestParameters.startCourseBuildBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiStartGuidedLabelSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiStartGuidedLabelSession(requestParameters: SkillApiApiSkillApiStartGuidedLabelSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartGuidedLabelSessionResponse> {
            return localVarFp.skillApiStartGuidedLabelSession(requestParameters.labelId, requestParameters.skillId, requestParameters.startGuidedLabelSessionBody, requestParameters.supportsBuilding, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiStartGuidedTopicSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiStartGuidedTopicSession(requestParameters: SkillApiApiSkillApiStartGuidedTopicSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartGuidedTopicSessionResponse> {
            return localVarFp.skillApiStartGuidedTopicSession(requestParameters.skillId, requestParameters.topicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiStartTopicJumpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiStartTopicJump(requestParameters: SkillApiApiSkillApiStartTopicJumpRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartGuidedTopicSessionResponse> {
            return localVarFp.skillApiStartTopicJump(requestParameters.skillId, requestParameters.topicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiSubmitCourseFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSubmitCourseFeedback(requestParameters: SkillApiApiSkillApiSubmitCourseFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmitCourseFeedbackResponse> {
            return localVarFp.skillApiSubmitCourseFeedback(requestParameters.skillId, requestParameters.submitCourseFeedbackBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiSubmitCourseReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiSubmitCourseReview(requestParameters: SkillApiApiSkillApiSubmitCourseReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmitCourseReviewResponse> {
            return localVarFp.skillApiSubmitCourseReview(requestParameters.skillId, requestParameters.submitCourseReviewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiTheoryAiChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiTheoryAiChat(requestParameters: SkillApiApiSkillApiTheoryAiChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<TheoryAIChatResponse> {
            return localVarFp.skillApiTheoryAiChat(requestParameters.skillId, requestParameters.theoryAIChatBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiToggleGuidedCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiToggleGuidedCourse(requestParameters: SkillApiApiSkillApiToggleGuidedCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<ToggleGuidedCourseResponse> {
            return localVarFp.skillApiToggleGuidedCourse(requestParameters.skillId, requestParameters.toggleGuidedCourseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiUpdateSkillAllowImagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpdateSkillAllowImages(requestParameters: SkillApiApiSkillApiUpdateSkillAllowImagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateAllowImagesResponse> {
            return localVarFp.skillApiUpdateSkillAllowImages(requestParameters.skillId, requestParameters.updateAllowImagesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiUpdateSkillCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpdateSkillCategories(requestParameters: SkillApiApiSkillApiUpdateSkillCategoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.skillApiUpdateSkillCategories(requestParameters.skillId, requestParameters.updateSkillCategoriesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiUpdateSkillFaqRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpdateSkillFaq(requestParameters: SkillApiApiSkillApiUpdateSkillFaqRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillFAQItem> {
            return localVarFp.skillApiUpdateSkillFaq(requestParameters.faqId, requestParameters.skillId, requestParameters.upsertSkillFAQBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiUpdateSkillHiddenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpdateSkillHidden(requestParameters: SkillApiApiSkillApiUpdateSkillHiddenRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSkillHiddenResponse> {
            return localVarFp.skillApiUpdateSkillHidden(requestParameters.skillId, requestParameters.updateSkillHiddenBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiUpdateSkillReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpdateSkillReview(requestParameters: SkillApiApiSkillApiUpdateSkillReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillReviewItem> {
            return localVarFp.skillApiUpdateSkillReview(requestParameters.reviewId, requestParameters.skillId, requestParameters.updateSkillReviewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiUpdateSkillSeriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpdateSkillSeries(requestParameters: SkillApiApiSkillApiUpdateSkillSeriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillSeriesItem> {
            return localVarFp.skillApiUpdateSkillSeries(requestParameters.seriesId, requestParameters.upsertSkillSeriesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiUploadSkillImagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUploadSkillImages(requestParameters: SkillApiApiSkillApiUploadSkillImagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillImageUploadResponse> {
            return localVarFp.skillApiUploadSkillImages(requestParameters.skillId, requestParameters.iconFile, requestParameters.headerImageFile, requestParameters.mobileHeaderFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SkillApiApiSkillApiUpsertSkillContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skillApiUpsertSkillContent(requestParameters: SkillApiApiSkillApiUpsertSkillContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillContentResponse> {
            return localVarFp.skillApiUpsertSkillContent(requestParameters.skillId, requestParameters.upsertSkillContentBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for skillApiAddCourseImageQuestions operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAddCourseImageQuestionsRequest {
    readonly moduleId: string

    readonly addCourseImageQuestionsBody: AddCourseImageQuestionsBody
}

/**
 * Request parameters for skillApiAddSeriesCourse operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAddSeriesCourseRequest {
    readonly seriesId: string

    readonly addSeriesCourseBody: AddSeriesCourseBody
}

/**
 * Request parameters for skillApiAddSkillRating operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAddSkillRatingRequest {
    readonly rating: string

    readonly skillId: string

    readonly userRatingParams: UserRatingParams
}

/**
 * Request parameters for skillApiAdminGenerateCourseIntros operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAdminGenerateCourseIntrosRequest {
    readonly moduleId: string

    readonly adminGenerateIntrosBody: AdminGenerateIntrosBody
}

/**
 * Request parameters for skillApiAdminGenerateMissingReadingMaterial operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAdminGenerateMissingReadingMaterialRequest {
    readonly skillId: string

    readonly adminGenerateReadingMaterialBody: AdminGenerateReadingMaterialBody
}

/**
 * Request parameters for skillApiAdminGenerateReadingMaterial operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAdminGenerateReadingMaterialRequest {
    readonly skillId: string

    readonly adminGenerateReadingMaterialBody: AdminGenerateReadingMaterialBody
}

/**
 * Request parameters for skillApiAdminGetCourseIntros operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAdminGetCourseIntrosRequest {
    readonly moduleId: string
}

/**
 * Request parameters for skillApiAdminGetReadingMaterialCostEstimate operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAdminGetReadingMaterialCostEstimateRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiAdminGetReadingMaterialStatus operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAdminGetReadingMaterialStatusRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiAdminNarrateCourse operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAdminNarrateCourseRequest {
    readonly skillId: string

    readonly adminNarrateBody: AdminNarrateBody
}

/**
 * Request parameters for skillApiAdminNarrateLabel operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAdminNarrateLabelRequest {
    readonly skillId: string

    readonly adminNarrateBody: AdminNarrateBody
}

/**
 * Request parameters for skillApiAdminNarrationCoverage operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAdminNarrationCoverageRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiAdminRegeneratePoorReadingMaterial operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAdminRegeneratePoorReadingMaterialRequest {
    readonly skillId: string

    readonly adminGenerateReadingMaterialBody: AdminGenerateReadingMaterialBody
}

/**
 * Request parameters for skillApiAdminRegenerateReadingMaterial operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAdminRegenerateReadingMaterialRequest {
    readonly skillId: string

    readonly adminRegenerateReadingMaterialBody: AdminRegenerateReadingMaterialBody
}

/**
 * Request parameters for skillApiAttemptGuidedQuestion operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAttemptGuidedQuestionRequest {
    readonly questionId: string

    readonly sessionId: string

    readonly attemptQuestionBody: AttemptQuestionBody
}

/**
 * Request parameters for skillApiAttemptTopicTestQuestion operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiAttemptTopicTestQuestionRequest {
    readonly questionId: string

    readonly sessionId: string

    readonly attemptQuestionBody: AttemptQuestionBody
}

/**
 * Request parameters for skillApiBackfillLiveCourseOpenings operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiBackfillLiveCourseOpeningsRequest {
    readonly openingBackfillBody: OpeningBackfillBody
}

/**
 * Request parameters for skillApiBulkCreateDomainsRoute operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiBulkCreateDomainsRouteRequest {
    readonly nameList: NameList
}

/**
 * Request parameters for skillApiBulkCreateModulesRoute operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiBulkCreateModulesRouteRequest {
    readonly iDNames: IDNames
}

/**
 * Request parameters for skillApiBulkCreateTopicSubtopicRoute operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiBulkCreateTopicSubtopicRouteRequest {
    readonly createTopicsSubtopicsBody: CreateTopicsSubtopicsBody
}

/**
 * Request parameters for skillApiCancelCourseBuildJob operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiCancelCourseBuildJobRequest {
    readonly jobId: string
}

/**
 * Request parameters for skillApiCancelCoursePromotion operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiCancelCoursePromotionRequest {
    readonly promotionId: string

    readonly skillId: string
}

/**
 * Request parameters for skillApiCheckSkillAliasAvailability operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiCheckSkillAliasAvailabilityRequest {
    readonly alias: string
}

/**
 * Request parameters for skillApiCloseTopicJump operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiCloseTopicJumpRequest {
    readonly sessionId: string
}

/**
 * Request parameters for skillApiCloseTopicTestSession operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiCloseTopicTestSessionRequest {
    readonly sessionId: string
}

/**
 * Request parameters for skillApiCompleteGuidedLabel operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiCompleteGuidedLabelRequest {
    readonly labelId: string

    readonly skillId: string
}

/**
 * Request parameters for skillApiCompleteIntro operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiCompleteIntroRequest {
    readonly nodeId: string

    readonly skillId: string
}

/**
 * Request parameters for skillApiContinueCourseBuildJob operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiContinueCourseBuildJobRequest {
    readonly jobId: string
}

/**
 * Request parameters for skillApiCourseBuildReadiness operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiCourseBuildReadinessRequest {
    readonly moduleId: string
}

/**
 * Request parameters for skillApiCreateCoursePromotion operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiCreateCoursePromotionRequest {
    readonly skillId: string

    readonly createCoursePromotionBody: CreateCoursePromotionBody
}

/**
 * Request parameters for skillApiCreateSkillFaq operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiCreateSkillFaqRequest {
    readonly skillId: string

    readonly upsertSkillFAQBody: UpsertSkillFAQBody
}

/**
 * Request parameters for skillApiCreateSkillReview operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiCreateSkillReviewRequest {
    readonly skillId: string

    readonly createSkillReviewBody: CreateSkillReviewBody
}

/**
 * Request parameters for skillApiCreateSkillSeries operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiCreateSkillSeriesRequest {
    readonly upsertSkillSeriesBody: UpsertSkillSeriesBody
}

/**
 * Request parameters for skillApiDeleteCourse operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiDeleteCourseRequest {
    readonly confirmName: string

    readonly skillId: string

    readonly dryRun?: boolean
}

/**
 * Request parameters for skillApiDeleteCourseReview operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiDeleteCourseReviewRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiDeleteSkillFaq operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiDeleteSkillFaqRequest {
    readonly faqId: string

    readonly skillId: string
}

/**
 * Request parameters for skillApiDeleteSkillReview operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiDeleteSkillReviewRequest {
    readonly reviewId: string

    readonly skillId: string
}

/**
 * Request parameters for skillApiDeleteSkillSeries operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiDeleteSkillSeriesRequest {
    readonly seriesId: string
}

/**
 * Request parameters for skillApiDismissCourseReview operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiDismissCourseReviewRequest {
    readonly skillId: string

    readonly dismissCourseReviewBody: DismissCourseReviewBody
}

/**
 * Request parameters for skillApiDismissProgressResetNotice operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiDismissProgressResetNoticeRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiDownloadGuidedCourseCertificate operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiDownloadGuidedCourseCertificateRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiDownloadSkillQuestions operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiDownloadSkillQuestionsRequest {
    readonly skillId: string

    readonly limit?: number | null
}

/**
 * Request parameters for skillApiEnrollGuidedCourse operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiEnrollGuidedCourseRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiEnsureLabelBuilt operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiEnsureLabelBuiltRequest {
    readonly labelId: string
}

/**
 * Request parameters for skillApiEstimateCourseBuild operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiEstimateCourseBuildRequest {
    readonly moduleId: string

    readonly contentModel?: string | null

    readonly labelLimit?: number | null

    readonly questionModel?: string | null

    readonly questionsPerLabel?: number | null
}

/**
 * Request parameters for skillApiGenerateCodingQuestions operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGenerateCodingQuestionsRequest {
    readonly skillId: string

    readonly generateCodingQuestionsBody: GenerateCodingQuestionsBody
}

/**
 * Request parameters for skillApiGenerateGuidedCourseCertificate operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGenerateGuidedCourseCertificateRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGenerateImageDensitySample operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGenerateImageDensitySampleRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGenerateImageOnlyQuestions operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGenerateImageOnlyQuestionsRequest {
    readonly skillId: string

    readonly generateImageOnlyQuestionsBody: GenerateImageOnlyQuestionsBody
}

/**
 * Request parameters for skillApiGetAdminSkillAnalytics operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetAdminSkillAnalyticsRequest {
    readonly maxDate?: string

    readonly minDate?: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly searchQuery?: string

    readonly skillId?: string | null

    readonly sortBy?: string | null

    readonly sortOrder?: string | null

    readonly totalPages?: number
}

/**
 * Request parameters for skillApiGetAdminSkillListBySkillType operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetAdminSkillListBySkillTypeRequest {
    readonly skillType: string

    readonly hasUnmapped?: boolean | null

    readonly isCurrentlyGenerating?: boolean | null

    readonly isGuidedCourse?: boolean | null

    readonly isPublicListed?: boolean | null

    readonly isSkillTreeAvailable?: boolean | null

    readonly maxMappedCount?: number | null

    readonly maxQuestionCount?: number | null

    readonly minMappedCount?: number | null

    readonly minQuestionCount?: number | null

    readonly missingIcon?: boolean | null

    readonly pageNo?: number

    readonly pageSize?: number

    readonly parentSkillId?: string | null

    readonly searchText?: string

    readonly sortBy?: string | null

    readonly sortOrder?: string | null

    readonly totalPages?: number
}

/**
 * Request parameters for skillApiGetCoreSkillDetail operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetCoreSkillDetailRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetCoreSkillGaps operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetCoreSkillGapsRequest {
    readonly view?: SkillApiGetCoreSkillGapsViewEnum
}

/**
 * Request parameters for skillApiGetCourseBuildHierarchy operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetCourseBuildHierarchyRequest {
    readonly moduleId: string
}

/**
 * Request parameters for skillApiGetCourseBuildJob operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetCourseBuildJobRequest {
    readonly jobId: string
}

/**
 * Request parameters for skillApiGetCourseImageQuestions operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetCourseImageQuestionsRequest {
    readonly moduleId: string
}

/**
 * Request parameters for skillApiGetCoursePromotion operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetCoursePromotionRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetGuidedCourseCertificate operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetGuidedCourseCertificateRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetGuidedCourseInfo operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetGuidedCourseInfoRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetGuidedCourseMap operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetGuidedCourseMapRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetGuidedCourseProgress operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetGuidedCourseProgressRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetGuidedCourses operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetGuidedCoursesRequest {
    readonly forceRefresh?: boolean

    readonly limit?: number | null

    readonly offset?: number | null

    readonly q?: string | null
}

/**
 * Request parameters for skillApiGetGuidedCurrentQuestion operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetGuidedCurrentQuestionRequest {
    readonly sessionId: string
}

/**
 * Request parameters for skillApiGetGuidedSessionProgress operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetGuidedSessionProgressRequest {
    readonly sessionId: string
}

/**
 * Request parameters for skillApiGetIntroContent operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetIntroContentRequest {
    readonly nodeId: string

    readonly skillId: string

    readonly forceWelcome?: boolean
}

/**
 * Request parameters for skillApiGetLabelBuildStatus operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetLabelBuildStatusRequest {
    readonly labelId: string

    readonly skillId: string

    readonly force?: boolean
}

/**
 * Request parameters for skillApiGetLabelContent operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetLabelContentRequest {
    readonly labelId: string

    readonly skillId: string

    readonly supportsBuilding?: boolean
}

/**
 * Request parameters for skillApiGetModulePublishStatus operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetModulePublishStatusRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetPublicSkillDetail operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetPublicSkillDetailRequest {
    readonly aliasOrId: string
}

/**
 * Request parameters for skillApiGetPublicSkillsHub operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetPublicSkillsHubRequest {
    readonly categories?: Array<string> | null

    readonly limit?: number | null

    readonly offset?: number | null

    readonly q?: string | null
}

/**
 * Request parameters for skillApiGetPublicSkillsList operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetPublicSkillsListRequest {
    readonly pageNo?: number

    readonly pageSize?: number

    readonly query?: string
}

/**
 * Request parameters for skillApiGetQuestionCreationSkillList operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetQuestionCreationSkillListRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly searchQuery?: string
}

/**
 * Request parameters for skillApiGetReadingMaterial operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetReadingMaterialRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetSkillBadges operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillBadgesRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetSkillBrowse operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillBrowseRequest {
    readonly category: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for skillApiGetSkillBuilderCertificate operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillBuilderCertificateRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetSkillBuilderCertificateProgress operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillBuilderCertificateProgressRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetSkillByIdV2 operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillByIdV2Request {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetSkillCategories operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillCategoriesRequest {
    readonly limit?: number

    readonly search?: string
}

/**
 * Request parameters for skillApiGetSkillContent operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillContentRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetSkillCostEstimate operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillCostEstimateRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetSkillGenerationPrompt operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillGenerationPromptRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetSkillList operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillListRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly searchQuery?: string
}

/**
 * Request parameters for skillApiGetSkillListV2 operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillListV2Request {
    readonly coreOnly?: boolean

    readonly searchQuery?: string

    readonly searchType?: string
}

/**
 * Request parameters for skillApiGetSkillModuleTodos operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillModuleTodosRequest {
    readonly domain?: string | null

    readonly pageNo?: number

    readonly pageSize?: number

    readonly searchText?: string

    readonly sortBy?: string | null

    readonly sortOrder?: string | null

    readonly step?: string | null

    readonly totalPages?: number
}

/**
 * Request parameters for skillApiGetSkillPercentile operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillPercentileRequest {
    readonly skillId: string

    readonly username?: string | null
}

/**
 * Request parameters for skillApiGetSkillPreference operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillPreferenceRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetSkillPublishReadiness operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillPublishReadinessRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetSkillRelatedCourses operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillRelatedCoursesRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetSkillReport operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillReportRequest {
    readonly skillId: string

    readonly username?: string | null
}

/**
 * Request parameters for skillApiGetSkillStartStatistics operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillStartStatisticsRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetSkillTree operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetSkillTreeRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiGetTheoryAiChats operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetTheoryAiChatsRequest {
    readonly skillId: string

    readonly cardIndex?: number | null
}

/**
 * Request parameters for skillApiGetTopicJumpResult operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetTopicJumpResultRequest {
    readonly sessionId: string
}

/**
 * Request parameters for skillApiGetTopicTestCurrentQuestion operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetTopicTestCurrentQuestionRequest {
    readonly sessionId: string

    readonly questionId?: string | null
}

/**
 * Request parameters for skillApiGetTopicTestProgress operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetTopicTestProgressRequest {
    readonly sessionId: string
}

/**
 * Request parameters for skillApiGetTopicTestResult operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetTopicTestResultRequest {
    readonly sessionId: string
}

/**
 * Request parameters for skillApiGetUserSkillDetails operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiGetUserSkillDetailsRequest {
    readonly skillId: string

    readonly userId: string
}

/**
 * Request parameters for skillApiListAdminCourseFeedback operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiListAdminCourseFeedbackRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly scope?: SkillApiListAdminCourseFeedbackScopeEnum

    readonly skillIds?: Array<string>
}

/**
 * Request parameters for skillApiListAdminCourses operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiListAdminCoursesRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly pricing?: string

    readonly q?: string | null

    readonly refreshed?: SkillApiListAdminCoursesRefreshedEnum

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly status?: string
}

/**
 * Request parameters for skillApiListCourseBuildJobs operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiListCourseBuildJobsRequest {
    readonly moduleId?: string | null

    readonly page?: number

    readonly pageSize?: number

    readonly status?: string | null
}

/**
 * Request parameters for skillApiListCoursePromotions operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiListCoursePromotionsRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiListSeriesCourses operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiListSeriesCoursesRequest {
    readonly seriesId: string
}

/**
 * Request parameters for skillApiListSkillFaqs operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiListSkillFaqsRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiListSkillReviews operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiListSkillReviewsRequest {
    readonly skillId: string

    readonly isFeatured?: boolean | null

    readonly pageNo?: number

    readonly pageSize?: number

    readonly source?: string | null

    readonly totalPages?: number
}

/**
 * Request parameters for skillApiListSkillSeries operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiListSkillSeriesRequest {
    readonly isPublicListed?: boolean | null

    readonly pageNo?: number

    readonly pageSize?: number

    readonly searchQuery?: string | null

    readonly totalPages?: number
}

/**
 * Request parameters for skillApiMergeDuplicatesByName operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiMergeDuplicatesByNameRequest {
    readonly dryRun?: boolean

    readonly limit?: number
}

/**
 * Request parameters for skillApiPreviewCoursePromotion operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiPreviewCoursePromotionRequest {
    readonly skillId: string

    readonly previewCoursePromotionBody: PreviewCoursePromotionBody
}

/**
 * Request parameters for skillApiPruneOrphanSkills operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiPruneOrphanSkillsRequest {
    readonly pruneOrphanSkillsBody: PruneOrphanSkillsBody
}

/**
 * Request parameters for skillApiPublishModule operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiPublishModuleRequest {
    readonly skillId: string

    readonly publishModuleBody: PublishModuleBody
}

/**
 * Request parameters for skillApiPurchaseGuidedCourse operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiPurchaseGuidedCourseRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiRebuildLabel operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiRebuildLabelRequest {
    readonly labelId: string

    readonly rebuildLabelBody: RebuildLabelBody
}

/**
 * Request parameters for skillApiRecomputeSkillImageDensity operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiRecomputeSkillImageDensityRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiRecomputeSkillQuality operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiRecomputeSkillQualityRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiRemoveSeriesCourse operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiRemoveSeriesCourseRequest {
    readonly seriesId: string

    readonly skillId: string
}

/**
 * Request parameters for skillApiRenameSkill operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiRenameSkillRequest {
    readonly name: string

    readonly skillId: string
}

/**
 * Request parameters for skillApiReorderSeriesCourses operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiReorderSeriesCoursesRequest {
    readonly seriesId: string

    readonly reorderSeriesBody: ReorderSeriesBody
}

/**
 * Request parameters for skillApiResetSkillPublicContent operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiResetSkillPublicContentRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiResolveCoreSkillReview operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiResolveCoreSkillReviewRequest {
    readonly skillId: string

    readonly resolveCoreSkillReviewBody: ResolveCoreSkillReviewBody
}

/**
 * Request parameters for skillApiRetryCourseBuildLabel operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiRetryCourseBuildLabelRequest {
    readonly labelTaskId: string
}

/**
 * Request parameters for skillApiReviewCoreSkills operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiReviewCoreSkillsRequest {
    readonly reviewCoreSkillsBody: ReviewCoreSkillsBody
}

/**
 * Request parameters for skillApiReviewHierarchyOrder operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiReviewHierarchyOrderRequest {
    readonly reviewHierarchyOrderBody: ReviewHierarchyOrderBody
}

/**
 * Request parameters for skillApiSaveMyStreak operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiSaveMyStreakRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiSendCoursePromotionTestEmail operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiSendCoursePromotionTestEmailRequest {
    readonly skillId: string

    readonly coursePromotionTestEmailBody: CoursePromotionTestEmailBody
}

/**
 * Request parameters for skillApiSetCoreSkillExclusion operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiSetCoreSkillExclusionRequest {
    readonly skillId: string

    readonly setCoreSkillExclusionBody: SetCoreSkillExclusionBody
}

/**
 * Request parameters for skillApiSetCourseIntroVisibility operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiSetCourseIntroVisibilityRequest {
    readonly skillId: string

    readonly setCourseIntroVisibilityBody: SetCourseIntroVisibilityBody
}

/**
 * Request parameters for skillApiSetCoursePricing operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiSetCoursePricingRequest {
    readonly skillId: string

    readonly setCoursePricingBody: SetCoursePricingBody
}

/**
 * Request parameters for skillApiSetSkillGenerationPrompt operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiSetSkillGenerationPromptRequest {
    readonly skillId: string

    readonly setSkillGenerationPromptBody: SetSkillGenerationPromptBody
}

/**
 * Request parameters for skillApiSetSkillPreference operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiSetSkillPreferenceRequest {
    readonly skillId: string

    readonly iDList: IDList
}

/**
 * Request parameters for skillApiSetSkillPublicListing operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiSetSkillPublicListingRequest {
    readonly skillId: string

    readonly publicListingBody: PublicListingBody
}

/**
 * Request parameters for skillApiSkillAiAssistantUnlock operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiSkillAiAssistantUnlockRequest {
    readonly skillId: string
}

/**
 * Request parameters for skillApiStartCourseBuild operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiStartCourseBuildRequest {
    readonly moduleId: string

    readonly startCourseBuildBody: StartCourseBuildBody
}

/**
 * Request parameters for skillApiStartGuidedLabelSession operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiStartGuidedLabelSessionRequest {
    readonly labelId: string

    readonly skillId: string

    readonly startGuidedLabelSessionBody: StartGuidedLabelSessionBody

    readonly supportsBuilding?: boolean
}

/**
 * Request parameters for skillApiStartGuidedTopicSession operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiStartGuidedTopicSessionRequest {
    readonly skillId: string

    readonly topicId: string
}

/**
 * Request parameters for skillApiStartTopicJump operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiStartTopicJumpRequest {
    readonly skillId: string

    readonly topicId: string
}

/**
 * Request parameters for skillApiSubmitCourseFeedback operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiSubmitCourseFeedbackRequest {
    readonly skillId: string

    readonly submitCourseFeedbackBody: SubmitCourseFeedbackBody
}

/**
 * Request parameters for skillApiSubmitCourseReview operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiSubmitCourseReviewRequest {
    readonly skillId: string

    readonly submitCourseReviewBody: SubmitCourseReviewBody
}

/**
 * Request parameters for skillApiTheoryAiChat operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiTheoryAiChatRequest {
    readonly skillId: string

    readonly theoryAIChatBody: TheoryAIChatBody
}

/**
 * Request parameters for skillApiToggleGuidedCourse operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiToggleGuidedCourseRequest {
    readonly skillId: string

    readonly toggleGuidedCourseBody: ToggleGuidedCourseBody
}

/**
 * Request parameters for skillApiUpdateSkillAllowImages operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiUpdateSkillAllowImagesRequest {
    readonly skillId: string

    readonly updateAllowImagesBody: UpdateAllowImagesBody
}

/**
 * Request parameters for skillApiUpdateSkillCategories operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiUpdateSkillCategoriesRequest {
    readonly skillId: string

    readonly updateSkillCategoriesBody: UpdateSkillCategoriesBody
}

/**
 * Request parameters for skillApiUpdateSkillFaq operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiUpdateSkillFaqRequest {
    readonly faqId: string

    readonly skillId: string

    readonly upsertSkillFAQBody: UpsertSkillFAQBody
}

/**
 * Request parameters for skillApiUpdateSkillHidden operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiUpdateSkillHiddenRequest {
    readonly skillId: string

    readonly updateSkillHiddenBody: UpdateSkillHiddenBody
}

/**
 * Request parameters for skillApiUpdateSkillReview operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiUpdateSkillReviewRequest {
    readonly reviewId: string

    readonly skillId: string

    readonly updateSkillReviewBody: UpdateSkillReviewBody
}

/**
 * Request parameters for skillApiUpdateSkillSeries operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiUpdateSkillSeriesRequest {
    readonly seriesId: string

    readonly upsertSkillSeriesBody: UpsertSkillSeriesBody
}

/**
 * Request parameters for skillApiUploadSkillImages operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiUploadSkillImagesRequest {
    readonly skillId: string

    readonly iconFile?: File

    readonly headerImageFile?: File

    readonly mobileHeaderFile?: File
}

/**
 * Request parameters for skillApiUpsertSkillContent operation in SkillApiApi.
 */
export interface SkillApiApiSkillApiUpsertSkillContentRequest {
    readonly skillId: string

    readonly upsertSkillContentBody: UpsertSkillContentBody
}

/**
 * SkillApiApi - object-oriented interface
 */
export class SkillApiApi extends BaseAPI {
    /**
     * checked against its figure before it goes live; re-running tops up the gap.
     * @summary Add figure questions to a course\'s built lessons. Each is judged, drawn and
     * @param {SkillApiApiSkillApiAddCourseImageQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAddCourseImageQuestions(requestParameters: SkillApiApiSkillApiAddCourseImageQuestionsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAddCourseImageQuestions(requestParameters.moduleId, requestParameters.addCourseImageQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAddSeriesCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAddSeriesCourse(requestParameters: SkillApiApiSkillApiAddSeriesCourseRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAddSeriesCourse(requestParameters.seriesId, requestParameters.addSeriesCourseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAddSkillRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAddSkillRating(requestParameters: SkillApiApiSkillApiAddSkillRatingRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAddSkillRating(requestParameters.rating, requestParameters.skillId, requestParameters.userRatingParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAdminGenerateCourseIntrosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAdminGenerateCourseIntros(requestParameters: SkillApiApiSkillApiAdminGenerateCourseIntrosRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAdminGenerateCourseIntros(requestParameters.moduleId, requestParameters.adminGenerateIntrosBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAdminGenerateMissingReadingMaterialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAdminGenerateMissingReadingMaterial(requestParameters: SkillApiApiSkillApiAdminGenerateMissingReadingMaterialRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAdminGenerateMissingReadingMaterial(requestParameters.skillId, requestParameters.adminGenerateReadingMaterialBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAdminGenerateReadingMaterialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAdminGenerateReadingMaterial(requestParameters: SkillApiApiSkillApiAdminGenerateReadingMaterialRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAdminGenerateReadingMaterial(requestParameters.skillId, requestParameters.adminGenerateReadingMaterialBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAdminGetCourseIntrosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAdminGetCourseIntros(requestParameters: SkillApiApiSkillApiAdminGetCourseIntrosRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAdminGetCourseIntros(requestParameters.moduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAdminGetReadingMaterialCostEstimateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAdminGetReadingMaterialCostEstimate(requestParameters: SkillApiApiSkillApiAdminGetReadingMaterialCostEstimateRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAdminGetReadingMaterialCostEstimate(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAdminGetReadingMaterialStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAdminGetReadingMaterialStatus(requestParameters: SkillApiApiSkillApiAdminGetReadingMaterialStatusRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAdminGetReadingMaterialStatus(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAdminNarrateCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAdminNarrateCourse(requestParameters: SkillApiApiSkillApiAdminNarrateCourseRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAdminNarrateCourse(requestParameters.skillId, requestParameters.adminNarrateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAdminNarrateLabelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAdminNarrateLabel(requestParameters: SkillApiApiSkillApiAdminNarrateLabelRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAdminNarrateLabel(requestParameters.skillId, requestParameters.adminNarrateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAdminNarrationCoverageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAdminNarrationCoverage(requestParameters: SkillApiApiSkillApiAdminNarrationCoverageRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAdminNarrationCoverage(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAdminRegeneratePoorReadingMaterialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAdminRegeneratePoorReadingMaterial(requestParameters: SkillApiApiSkillApiAdminRegeneratePoorReadingMaterialRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAdminRegeneratePoorReadingMaterial(requestParameters.skillId, requestParameters.adminGenerateReadingMaterialBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAdminRegenerateReadingMaterialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAdminRegenerateReadingMaterial(requestParameters: SkillApiApiSkillApiAdminRegenerateReadingMaterialRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAdminRegenerateReadingMaterial(requestParameters.skillId, requestParameters.adminRegenerateReadingMaterialBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAttemptGuidedQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAttemptGuidedQuestion(requestParameters: SkillApiApiSkillApiAttemptGuidedQuestionRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAttemptGuidedQuestion(requestParameters.questionId, requestParameters.sessionId, requestParameters.attemptQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiAttemptTopicTestQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiAttemptTopicTestQuestion(requestParameters: SkillApiApiSkillApiAttemptTopicTestQuestionRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiAttemptTopicTestQuestion(requestParameters.questionId, requestParameters.sessionId, requestParameters.attemptQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The same sweep the cron runs. Exposed because beat only fires in PROD, so this is the only way to exercise it anywhere else — and `dry_run` answers \"which live courses are hollow right now\" without spending anything.
     * @summary Build the opening lessons of any live course still missing them.
     * @param {SkillApiApiSkillApiBackfillLiveCourseOpeningsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiBackfillLiveCourseOpenings(requestParameters: SkillApiApiSkillApiBackfillLiveCourseOpeningsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiBackfillLiveCourseOpenings(requestParameters.openingBackfillBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiBulkCreateDomainsRouteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiBulkCreateDomainsRoute(requestParameters: SkillApiApiSkillApiBulkCreateDomainsRouteRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiBulkCreateDomainsRoute(requestParameters.nameList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiBulkCreateModulesRouteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiBulkCreateModulesRoute(requestParameters: SkillApiApiSkillApiBulkCreateModulesRouteRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiBulkCreateModulesRoute(requestParameters.iDNames, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiBulkCreateTopicSubtopicRouteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiBulkCreateTopicSubtopicRoute(requestParameters: SkillApiApiSkillApiBulkCreateTopicSubtopicRouteRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiBulkCreateTopicSubtopicRoute(requestParameters.createTopicsSubtopicsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiCancelCourseBuildJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiCancelCourseBuildJob(requestParameters: SkillApiApiSkillApiCancelCourseBuildJobRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiCancelCourseBuildJob(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiCancelCoursePromotionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiCancelCoursePromotion(requestParameters: SkillApiApiSkillApiCancelCoursePromotionRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiCancelCoursePromotion(requestParameters.promotionId, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiCheckSkillAliasAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiCheckSkillAliasAvailability(requestParameters: SkillApiApiSkillApiCheckSkillAliasAvailabilityRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiCheckSkillAliasAvailability(requestParameters.alias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiCloseTopicJumpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiCloseTopicJump(requestParameters: SkillApiApiSkillApiCloseTopicJumpRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiCloseTopicJump(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiCloseTopicTestSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiCloseTopicTestSession(requestParameters: SkillApiApiSkillApiCloseTopicTestSessionRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiCloseTopicTestSession(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiCompleteGuidedLabelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiCompleteGuidedLabel(requestParameters: SkillApiApiSkillApiCompleteGuidedLabelRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiCompleteGuidedLabel(requestParameters.labelId, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiCompleteIntroRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiCompleteIntro(requestParameters: SkillApiApiSkillApiCompleteIntroRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiCompleteIntro(requestParameters.nodeId, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiContinueCourseBuildJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiContinueCourseBuildJob(requestParameters: SkillApiApiSkillApiContinueCourseBuildJobRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiContinueCourseBuildJob(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiContinueStalledCourseBuildJobs(options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiContinueStalledCourseBuildJobs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiCourseBuildReadinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiCourseBuildReadiness(requestParameters: SkillApiApiSkillApiCourseBuildReadinessRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiCourseBuildReadiness(requestParameters.moduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiCreateCoursePromotionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiCreateCoursePromotion(requestParameters: SkillApiApiSkillApiCreateCoursePromotionRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiCreateCoursePromotion(requestParameters.skillId, requestParameters.createCoursePromotionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiCreateSkillFaqRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiCreateSkillFaq(requestParameters: SkillApiApiSkillApiCreateSkillFaqRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiCreateSkillFaq(requestParameters.skillId, requestParameters.upsertSkillFAQBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiCreateSkillReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiCreateSkillReview(requestParameters: SkillApiApiSkillApiCreateSkillReviewRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiCreateSkillReview(requestParameters.skillId, requestParameters.createSkillReviewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiCreateSkillSeriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiCreateSkillSeries(requestParameters: SkillApiApiSkillApiCreateSkillSeriesRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiCreateSkillSeries(requestParameters.upsertSkillSeriesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiDeleteCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiDeleteCourse(requestParameters: SkillApiApiSkillApiDeleteCourseRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiDeleteCourse(requestParameters.confirmName, requestParameters.skillId, requestParameters.dryRun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiDeleteCourseReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiDeleteCourseReview(requestParameters: SkillApiApiSkillApiDeleteCourseReviewRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiDeleteCourseReview(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiDeleteSkillFaqRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiDeleteSkillFaq(requestParameters: SkillApiApiSkillApiDeleteSkillFaqRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiDeleteSkillFaq(requestParameters.faqId, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiDeleteSkillReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiDeleteSkillReview(requestParameters: SkillApiApiSkillApiDeleteSkillReviewRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiDeleteSkillReview(requestParameters.reviewId, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiDeleteSkillSeriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiDeleteSkillSeries(requestParameters: SkillApiApiSkillApiDeleteSkillSeriesRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiDeleteSkillSeries(requestParameters.seriesId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiDismissCourseReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiDismissCourseReview(requestParameters: SkillApiApiSkillApiDismissCourseReviewRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiDismissCourseReview(requestParameters.skillId, requestParameters.dismissCourseReviewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiDismissProgressResetNoticeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiDismissProgressResetNotice(requestParameters: SkillApiApiSkillApiDismissProgressResetNoticeRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiDismissProgressResetNotice(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiDownloadGuidedCourseCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiDownloadGuidedCourseCertificate(requestParameters: SkillApiApiSkillApiDownloadGuidedCourseCertificateRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiDownloadGuidedCourseCertificate(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiDownloadSkillQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiDownloadSkillQuestions(requestParameters: SkillApiApiSkillApiDownloadSkillQuestionsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiDownloadSkillQuestions(requestParameters.skillId, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiEnrollGuidedCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiEnrollGuidedCourse(requestParameters: SkillApiApiSkillApiEnrollGuidedCourseRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiEnrollGuidedCourse(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * entry point the learner flow will call when it reaches an unbuilt label.
     * @summary Build a single label on demand. Admin-facing for now; this is the same
     * @param {SkillApiApiSkillApiEnsureLabelBuiltRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiEnsureLabelBuilt(requestParameters: SkillApiApiSkillApiEnsureLabelBuiltRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiEnsureLabelBuilt(requestParameters.labelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiEstimateCourseBuildRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiEstimateCourseBuild(requestParameters: SkillApiApiSkillApiEstimateCourseBuildRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiEstimateCourseBuild(requestParameters.moduleId, requestParameters.contentModel, requestParameters.labelLimit, requestParameters.questionModel, requestParameters.questionsPerLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGenerateCodingQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGenerateCodingQuestions(requestParameters: SkillApiApiSkillApiGenerateCodingQuestionsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGenerateCodingQuestions(requestParameters.skillId, requestParameters.generateCodingQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGenerateGuidedCourseCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGenerateGuidedCourseCertificate(requestParameters: SkillApiApiSkillApiGenerateGuidedCourseCertificateRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGenerateGuidedCourseCertificate(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGenerateImageDensitySampleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGenerateImageDensitySample(requestParameters: SkillApiApiSkillApiGenerateImageDensitySampleRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGenerateImageDensitySample(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGenerateImageOnlyQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGenerateImageOnlyQuestions(requestParameters: SkillApiApiSkillApiGenerateImageOnlyQuestionsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGenerateImageOnlyQuestions(requestParameters.skillId, requestParameters.generateImageOnlyQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetAdminSkillAnalyticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetAdminSkillAnalytics(requestParameters: SkillApiApiSkillApiGetAdminSkillAnalyticsRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetAdminSkillAnalytics(requestParameters.maxDate, requestParameters.minDate, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.skillId, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetAdminSkillListBySkillTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetAdminSkillListBySkillType(requestParameters: SkillApiApiSkillApiGetAdminSkillListBySkillTypeRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetAdminSkillListBySkillType(requestParameters.skillType, requestParameters.hasUnmapped, requestParameters.isCurrentlyGenerating, requestParameters.isGuidedCourse, requestParameters.isPublicListed, requestParameters.isSkillTreeAvailable, requestParameters.maxMappedCount, requestParameters.maxQuestionCount, requestParameters.minMappedCount, requestParameters.minQuestionCount, requestParameters.missingIcon, requestParameters.pageNo, requestParameters.pageSize, requestParameters.parentSkillId, requestParameters.searchText, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetCoreSkillDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetCoreSkillDetail(requestParameters: SkillApiApiSkillApiGetCoreSkillDetailRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetCoreSkillDetail(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetCoreSkillDuplicates(options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetCoreSkillDuplicates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetCoreSkillGapsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetCoreSkillGaps(requestParameters: SkillApiApiSkillApiGetCoreSkillGapsRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetCoreSkillGaps(requestParameters.view, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * dict — Flask\'s JSON provider sorts object keys and would scramble it).
     * @summary The module\'s saved hierarchy in true teaching order (ordered list, not a
     * @param {SkillApiApiSkillApiGetCourseBuildHierarchyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetCourseBuildHierarchy(requestParameters: SkillApiApiSkillApiGetCourseBuildHierarchyRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetCourseBuildHierarchy(requestParameters.moduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetCourseBuildJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetCourseBuildJob(requestParameters: SkillApiApiSkillApiGetCourseBuildJobRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetCourseBuildJob(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetCourseImageQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetCourseImageQuestions(requestParameters: SkillApiApiSkillApiGetCourseImageQuestionsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetCourseImageQuestions(requestParameters.moduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetCoursePromotionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetCoursePromotion(requestParameters: SkillApiApiSkillApiGetCoursePromotionRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetCoursePromotion(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetGuidedCourseCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetGuidedCourseCertificate(requestParameters: SkillApiApiSkillApiGetGuidedCourseCertificateRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetGuidedCourseCertificate(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetGuidedCourseInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetGuidedCourseInfo(requestParameters: SkillApiApiSkillApiGetGuidedCourseInfoRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetGuidedCourseInfo(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetGuidedCourseMapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetGuidedCourseMap(requestParameters: SkillApiApiSkillApiGetGuidedCourseMapRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetGuidedCourseMap(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetGuidedCourseProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetGuidedCourseProgress(requestParameters: SkillApiApiSkillApiGetGuidedCourseProgressRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetGuidedCourseProgress(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetGuidedCourseRelevance(options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetGuidedCourseRelevance(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetGuidedCoursesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetGuidedCourses(requestParameters: SkillApiApiSkillApiGetGuidedCoursesRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetGuidedCourses(requestParameters.forceRefresh, requestParameters.limit, requestParameters.offset, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetGuidedCoursesProgress(options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetGuidedCoursesProgress(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetGuidedCurrentQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetGuidedCurrentQuestion(requestParameters: SkillApiApiSkillApiGetGuidedCurrentQuestionRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetGuidedCurrentQuestion(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetGuidedSessionProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetGuidedSessionProgress(requestParameters: SkillApiApiSkillApiGetGuidedSessionProgressRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetGuidedSessionProgress(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetIntroContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetIntroContent(requestParameters: SkillApiApiSkillApiGetIntroContentRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetIntroContent(requestParameters.nodeId, requestParameters.skillId, requestParameters.forceWelcome, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Polled by the lesson loader. Also starts the build when nothing is running, so a lesson whose build died recovers without the learner doing anything — except right after one gave up, which needs `force` (the retry button).
     * @summary Progress of the lesson the learner is waiting on.
     * @param {SkillApiApiSkillApiGetLabelBuildStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetLabelBuildStatus(requestParameters: SkillApiApiSkillApiGetLabelBuildStatusRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetLabelBuildStatus(requestParameters.labelId, requestParameters.skillId, requestParameters.force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetLabelContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetLabelContent(requestParameters: SkillApiApiSkillApiGetLabelContentRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetLabelContent(requestParameters.labelId, requestParameters.skillId, requestParameters.supportsBuilding, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetModulePublishStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetModulePublishStatus(requestParameters: SkillApiApiSkillApiGetModulePublishStatusRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetModulePublishStatus(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetPublicSeriesList(options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetPublicSeriesList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetPublicSkillDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetPublicSkillDetail(requestParameters: SkillApiApiSkillApiGetPublicSkillDetailRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetPublicSkillDetail(requestParameters.aliasOrId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetPublicSkillsHubRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetPublicSkillsHub(requestParameters: SkillApiApiSkillApiGetPublicSkillsHubRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetPublicSkillsHub(requestParameters.categories, requestParameters.limit, requestParameters.offset, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetPublicSkillsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetPublicSkillsList(requestParameters: SkillApiApiSkillApiGetPublicSkillsListRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetPublicSkillsList(requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetQuestionCreationSkillListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetQuestionCreationSkillList(requestParameters: SkillApiApiSkillApiGetQuestionCreationSkillListRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetQuestionCreationSkillList(requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetReadingMaterialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetReadingMaterial(requestParameters: SkillApiApiSkillApiGetReadingMaterialRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetReadingMaterial(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillBadgesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillBadges(requestParameters: SkillApiApiSkillApiGetSkillBadgesRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillBadges(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillBrowseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillBrowse(requestParameters: SkillApiApiSkillApiGetSkillBrowseRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillBrowse(requestParameters.category, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillBuilderCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillBuilderCertificate(requestParameters: SkillApiApiSkillApiGetSkillBuilderCertificateRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillBuilderCertificate(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillBuilderCertificateProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillBuilderCertificateProgress(requestParameters: SkillApiApiSkillApiGetSkillBuilderCertificateProgressRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillBuilderCertificateProgress(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillByIdV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillByIdV2(requestParameters: SkillApiApiSkillApiGetSkillByIdV2Request, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillByIdV2(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillCategories(requestParameters: SkillApiApiSkillApiGetSkillCategoriesRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillCategories(requestParameters.limit, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillContent(requestParameters: SkillApiApiSkillApiGetSkillContentRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillContent(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillCostEstimateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillCostEstimate(requestParameters: SkillApiApiSkillApiGetSkillCostEstimateRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillCostEstimate(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillDashboardSummary(options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillDashboardSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This skill\'s AI-generation guidance plus what it inherits from ancestors.
     * @param {SkillApiApiSkillApiGetSkillGenerationPromptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillGenerationPrompt(requestParameters: SkillApiApiSkillApiGetSkillGenerationPromptRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillGenerationPrompt(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillList(requestParameters: SkillApiApiSkillApiGetSkillListRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillList(requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillListV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillListV2(requestParameters: SkillApiApiSkillApiGetSkillListV2Request = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillListV2(requestParameters.coreOnly, requestParameters.searchQuery, requestParameters.searchType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillModuleTodosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillModuleTodos(requestParameters: SkillApiApiSkillApiGetSkillModuleTodosRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillModuleTodos(requestParameters.domain, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchText, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.step, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillPercentileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillPercentile(requestParameters: SkillApiApiSkillApiGetSkillPercentileRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillPercentile(requestParameters.skillId, requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillPreferenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillPreference(requestParameters: SkillApiApiSkillApiGetSkillPreferenceRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillPreference(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillPublishReadinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillPublishReadiness(requestParameters: SkillApiApiSkillApiGetSkillPublishReadinessRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillPublishReadiness(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillRelatedCoursesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillRelatedCourses(requestParameters: SkillApiApiSkillApiGetSkillRelatedCoursesRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillRelatedCourses(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillReport(requestParameters: SkillApiApiSkillApiGetSkillReportRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillReport(requestParameters.skillId, requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillStartStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillStartStatistics(requestParameters: SkillApiApiSkillApiGetSkillStartStatisticsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillStartStatistics(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetSkillTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetSkillTree(requestParameters: SkillApiApiSkillApiGetSkillTreeRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetSkillTree(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetTheoryAiChatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetTheoryAiChats(requestParameters: SkillApiApiSkillApiGetTheoryAiChatsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetTheoryAiChats(requestParameters.skillId, requestParameters.cardIndex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetTopicJumpResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetTopicJumpResult(requestParameters: SkillApiApiSkillApiGetTopicJumpResultRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetTopicJumpResult(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetTopicTestCurrentQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetTopicTestCurrentQuestion(requestParameters: SkillApiApiSkillApiGetTopicTestCurrentQuestionRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetTopicTestCurrentQuestion(requestParameters.sessionId, requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetTopicTestProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetTopicTestProgress(requestParameters: SkillApiApiSkillApiGetTopicTestProgressRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetTopicTestProgress(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetTopicTestResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetTopicTestResult(requestParameters: SkillApiApiSkillApiGetTopicTestResultRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetTopicTestResult(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiGetUserSkillDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiGetUserSkillDetails(requestParameters: SkillApiApiSkillApiGetUserSkillDetailsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiGetUserSkillDetails(requestParameters.skillId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiListAdminCourseFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiListAdminCourseFeedback(requestParameters: SkillApiApiSkillApiListAdminCourseFeedbackRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiListAdminCourseFeedback(requestParameters.page, requestParameters.pageSize, requestParameters.scope, requestParameters.skillIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiListAdminCoursesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiListAdminCourses(requestParameters: SkillApiApiSkillApiListAdminCoursesRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiListAdminCourses(requestParameters.page, requestParameters.pageSize, requestParameters.pricing, requestParameters.q, requestParameters.refreshed, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiListCourseBuildJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiListCourseBuildJobs(requestParameters: SkillApiApiSkillApiListCourseBuildJobsRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiListCourseBuildJobs(requestParameters.moduleId, requestParameters.page, requestParameters.pageSize, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiListCoursePromotionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiListCoursePromotions(requestParameters: SkillApiApiSkillApiListCoursePromotionsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiListCoursePromotions(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiListSeriesCoursesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiListSeriesCourses(requestParameters: SkillApiApiSkillApiListSeriesCoursesRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiListSeriesCourses(requestParameters.seriesId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiListSkillFaqsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiListSkillFaqs(requestParameters: SkillApiApiSkillApiListSkillFaqsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiListSkillFaqs(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiListSkillReviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiListSkillReviews(requestParameters: SkillApiApiSkillApiListSkillReviewsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiListSkillReviews(requestParameters.skillId, requestParameters.isFeatured, requestParameters.pageNo, requestParameters.pageSize, requestParameters.source, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiListSkillSeriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiListSkillSeries(requestParameters: SkillApiApiSkillApiListSkillSeriesRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiListSkillSeries(requestParameters.isPublicListed, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiMergeDuplicatesByNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiMergeDuplicatesByName(requestParameters: SkillApiApiSkillApiMergeDuplicatesByNameRequest = {}, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiMergeDuplicatesByName(requestParameters.dryRun, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiPreviewCoursePromotionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiPreviewCoursePromotion(requestParameters: SkillApiApiSkillApiPreviewCoursePromotionRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiPreviewCoursePromotion(requestParameters.skillId, requestParameters.previewCoursePromotionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiPruneOrphanSkillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiPruneOrphanSkills(requestParameters: SkillApiApiSkillApiPruneOrphanSkillsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiPruneOrphanSkills(requestParameters.pruneOrphanSkillsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiPublishModuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiPublishModule(requestParameters: SkillApiApiSkillApiPublishModuleRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiPublishModule(requestParameters.skillId, requestParameters.publishModuleBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiPurchaseGuidedCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiPurchaseGuidedCourse(requestParameters: SkillApiApiSkillApiPurchaseGuidedCourseRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiPurchaseGuidedCourse(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set the label\'s generation-prompt first — a rebuild with no guidance regenerates the same lesson from the same inputs.
     * @summary Replace a lesson: retire its questions, rewrite its cards, rebuild both.
     * @param {SkillApiApiSkillApiRebuildLabelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiRebuildLabel(requestParameters: SkillApiApiSkillApiRebuildLabelRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiRebuildLabel(requestParameters.labelId, requestParameters.rebuildLabelBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiRecomputeCoreSkills(options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiRecomputeCoreSkills(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiRecomputeSkillImageDensityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiRecomputeSkillImageDensity(requestParameters: SkillApiApiSkillApiRecomputeSkillImageDensityRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiRecomputeSkillImageDensity(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiRecomputeSkillQualityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiRecomputeSkillQuality(requestParameters: SkillApiApiSkillApiRecomputeSkillQualityRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiRecomputeSkillQuality(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiRefillHearts(options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiRefillHearts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiRemoveSeriesCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiRemoveSeriesCourse(requestParameters: SkillApiApiSkillApiRemoveSeriesCourseRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiRemoveSeriesCourse(requestParameters.seriesId, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiRenameSkillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiRenameSkill(requestParameters: SkillApiApiSkillApiRenameSkillRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiRenameSkill(requestParameters.name, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiReorderSeriesCoursesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiReorderSeriesCourses(requestParameters: SkillApiApiSkillApiReorderSeriesCoursesRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiReorderSeriesCourses(requestParameters.seriesId, requestParameters.reorderSeriesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiResetSkillPublicContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiResetSkillPublicContent(requestParameters: SkillApiApiSkillApiResetSkillPublicContentRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiResetSkillPublicContent(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiResolveCoreSkillReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiResolveCoreSkillReview(requestParameters: SkillApiApiSkillApiResolveCoreSkillReviewRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiResolveCoreSkillReview(requestParameters.skillId, requestParameters.resolveCoreSkillReviewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiRetryCourseBuildLabelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiRetryCourseBuildLabel(requestParameters: SkillApiApiSkillApiRetryCourseBuildLabelRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiRetryCourseBuildLabel(requestParameters.labelTaskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiReviewCoreSkillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiReviewCoreSkills(requestParameters: SkillApiApiSkillApiReviewCoreSkillsRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiReviewCoreSkills(requestParameters.reviewCoreSkillsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The from-scratch wizard uses this so the admin can see the improved order (and why it is better) before committing — nothing is persisted here.
     * @summary Pedagogical order review for a hierarchy that has not been saved yet.
     * @param {SkillApiApiSkillApiReviewHierarchyOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiReviewHierarchyOrder(requestParameters: SkillApiApiSkillApiReviewHierarchyOrderRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiReviewHierarchyOrder(requestParameters.reviewHierarchyOrderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiSaveMyStreakRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiSaveMyStreak(requestParameters: SkillApiApiSkillApiSaveMyStreakRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiSaveMyStreak(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiSendCoursePromotionTestEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiSendCoursePromotionTestEmail(requestParameters: SkillApiApiSkillApiSendCoursePromotionTestEmailRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiSendCoursePromotionTestEmail(requestParameters.skillId, requestParameters.coursePromotionTestEmailBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiSetCoreSkillExclusionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiSetCoreSkillExclusion(requestParameters: SkillApiApiSkillApiSetCoreSkillExclusionRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiSetCoreSkillExclusion(requestParameters.skillId, requestParameters.setCoreSkillExclusionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiSetCourseIntroVisibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiSetCourseIntroVisibility(requestParameters: SkillApiApiSkillApiSetCourseIntroVisibilityRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiSetCourseIntroVisibility(requestParameters.skillId, requestParameters.setCourseIntroVisibilityBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiSetCoursePricingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiSetCoursePricing(requestParameters: SkillApiApiSkillApiSetCoursePricingRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiSetCoursePricing(requestParameters.skillId, requestParameters.setCoursePricingBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Takes effect the next time that part of the tree is generated — writing it regenerates nothing on its own.
     * @summary Set or clear generation guidance on any level (Module/Topic/SubTopic/Label).
     * @param {SkillApiApiSkillApiSetSkillGenerationPromptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiSetSkillGenerationPrompt(requestParameters: SkillApiApiSkillApiSetSkillGenerationPromptRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiSetSkillGenerationPrompt(requestParameters.skillId, requestParameters.setSkillGenerationPromptBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiSetSkillPreferenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiSetSkillPreference(requestParameters: SkillApiApiSkillApiSetSkillPreferenceRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiSetSkillPreference(requestParameters.skillId, requestParameters.iDList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiSetSkillPublicListingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiSetSkillPublicListing(requestParameters: SkillApiApiSkillApiSetSkillPublicListingRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiSetSkillPublicListing(requestParameters.skillId, requestParameters.publicListingBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiSkillAiAssistantUnlockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiSkillAiAssistantUnlock(requestParameters: SkillApiApiSkillApiSkillAiAssistantUnlockRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiSkillAiAssistantUnlock(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiStartCourseBuildRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiStartCourseBuild(requestParameters: SkillApiApiSkillApiStartCourseBuildRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiStartCourseBuild(requestParameters.moduleId, requestParameters.startCourseBuildBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiStartGuidedLabelSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiStartGuidedLabelSession(requestParameters: SkillApiApiSkillApiStartGuidedLabelSessionRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiStartGuidedLabelSession(requestParameters.labelId, requestParameters.skillId, requestParameters.startGuidedLabelSessionBody, requestParameters.supportsBuilding, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiStartGuidedTopicSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiStartGuidedTopicSession(requestParameters: SkillApiApiSkillApiStartGuidedTopicSessionRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiStartGuidedTopicSession(requestParameters.skillId, requestParameters.topicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiStartTopicJumpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiStartTopicJump(requestParameters: SkillApiApiSkillApiStartTopicJumpRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiStartTopicJump(requestParameters.skillId, requestParameters.topicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiSubmitCourseFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiSubmitCourseFeedback(requestParameters: SkillApiApiSkillApiSubmitCourseFeedbackRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiSubmitCourseFeedback(requestParameters.skillId, requestParameters.submitCourseFeedbackBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiSubmitCourseReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiSubmitCourseReview(requestParameters: SkillApiApiSkillApiSubmitCourseReviewRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiSubmitCourseReview(requestParameters.skillId, requestParameters.submitCourseReviewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiTheoryAiChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiTheoryAiChat(requestParameters: SkillApiApiSkillApiTheoryAiChatRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiTheoryAiChat(requestParameters.skillId, requestParameters.theoryAIChatBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiToggleGuidedCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiToggleGuidedCourse(requestParameters: SkillApiApiSkillApiToggleGuidedCourseRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiToggleGuidedCourse(requestParameters.skillId, requestParameters.toggleGuidedCourseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiUpdateSkillAllowImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiUpdateSkillAllowImages(requestParameters: SkillApiApiSkillApiUpdateSkillAllowImagesRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiUpdateSkillAllowImages(requestParameters.skillId, requestParameters.updateAllowImagesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiUpdateSkillCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiUpdateSkillCategories(requestParameters: SkillApiApiSkillApiUpdateSkillCategoriesRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiUpdateSkillCategories(requestParameters.skillId, requestParameters.updateSkillCategoriesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiUpdateSkillFaqRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiUpdateSkillFaq(requestParameters: SkillApiApiSkillApiUpdateSkillFaqRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiUpdateSkillFaq(requestParameters.faqId, requestParameters.skillId, requestParameters.upsertSkillFAQBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiUpdateSkillHiddenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiUpdateSkillHidden(requestParameters: SkillApiApiSkillApiUpdateSkillHiddenRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiUpdateSkillHidden(requestParameters.skillId, requestParameters.updateSkillHiddenBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiUpdateSkillReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiUpdateSkillReview(requestParameters: SkillApiApiSkillApiUpdateSkillReviewRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiUpdateSkillReview(requestParameters.reviewId, requestParameters.skillId, requestParameters.updateSkillReviewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiUpdateSkillSeriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiUpdateSkillSeries(requestParameters: SkillApiApiSkillApiUpdateSkillSeriesRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiUpdateSkillSeries(requestParameters.seriesId, requestParameters.upsertSkillSeriesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiUploadSkillImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiUploadSkillImages(requestParameters: SkillApiApiSkillApiUploadSkillImagesRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiUploadSkillImages(requestParameters.skillId, requestParameters.iconFile, requestParameters.headerImageFile, requestParameters.mobileHeaderFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SkillApiApiSkillApiUpsertSkillContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skillApiUpsertSkillContent(requestParameters: SkillApiApiSkillApiUpsertSkillContentRequest, options?: RawAxiosRequestConfig) {
        return SkillApiApiFp(this.configuration).skillApiUpsertSkillContent(requestParameters.skillId, requestParameters.upsertSkillContentBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const SkillApiGetCoreSkillGapsViewEnum = {
    Blocked: 'blocked',
    All: 'all',
    Excluded: 'excluded',
    Suggested: 'suggested',
} as const;
export type SkillApiGetCoreSkillGapsViewEnum = typeof SkillApiGetCoreSkillGapsViewEnum[keyof typeof SkillApiGetCoreSkillGapsViewEnum];
export const SkillApiListAdminCourseFeedbackScopeEnum = {
    Label: 'label',
    Topic: 'topic',
    Course: 'course',
} as const;
export type SkillApiListAdminCourseFeedbackScopeEnum = typeof SkillApiListAdminCourseFeedbackScopeEnum[keyof typeof SkillApiListAdminCourseFeedbackScopeEnum];
export const SkillApiListAdminCoursesRefreshedEnum = {
    All: 'all',
    Never: 'never',
} as const;
export type SkillApiListAdminCoursesRefreshedEnum = typeof SkillApiListAdminCoursesRefreshedEnum[keyof typeof SkillApiListAdminCoursesRefreshedEnum];
